<template>
  <div>
    <CRow>
      <CModal :show.sync="darkModal" :no-close-on-backdrop="true" :centered="true" title="Modal title 2" color="warning"
        v-show="showModal" class="modal-debitos">
        <CDataTable :items="dadosPacienteMulta" :fields="fields" hover sorter small pagination>
          <template #acao="{ item, index }">
            <td>
              <CInputCheckbox :disabled="desabilitarCheckBoxModal" square @click="marcar(item, index)">EXCLUIR
              </CInputCheckbox>
            </td>
          </template>
        </CDataTable>
        <template #header>
          <h4 class="modal-title">Paciente está em débito de outras consultas</h4>
          <CButtonClose @click="cancelar()" class="text-white" />
        </template>
        <template>
          <section class="title-cite-modal">
            <cite title="Informações do Pagamento">Informações do Pagamento</cite>
          </section>
          <section class="section-modal-debitos">
            <CInput type="date" v-model="dataModal" />
            <CSelect style="margin-left: 1vw" :value.sync="pagamentoModalSelecionado" :options="listaPagamentosModal"
              placeholder="Selecione o pagamento" @change="formaPagamentoModal" />
          </section>
        </template>
        <template>
          <CButton @click="cancelar()" color="info">Voltar</CButton>
          <CButton :disabled="desabilitarSomar" style="margin-left: 0.5em" @click="atualizarDebitos()" color="success">
            Atualizar</CButton>
        </template>
      </CModal>
      <CCol>
        <div class="container-card">
          <span class="status">{{ this.consulta.statusconsulta }}</span>
          <CCard>
            <CCardBody>
              <CModal class="modal-excluir-consulta" :show.sync="showModalFinanceiro">
                <div class="div-body-modal">
                  <img src="../../../assets/atencao.jpg" width="120px" height="120px" alt="" />
                  <h4>ATENÇÃO</h4>
                  <p>Os dados financeiros só podem ser alterados no dia da consulta.</p>

                  <button type="button" class="btn-modal" @click="showModalFinanceiro = false">
                    CANCELAR
                  </button>
                </div>
              </CModal>
              <CAlert color="warning" id="aviso" name="aviso" :show.sync="alertPessoa" closeButton>Informe Nome, Cargo e
                Gênero para confirmar!</CAlert>

              <CAlert color="success" id="sucesso" name="sucesso" :show.sync="sucesso" closeButton>{{ mensagem }}</CAlert>
              <CAlert color="warning" id="sucesso" name="sucesso" :show.sync="aviso" closeButton>{{ mensagem }}</CAlert>
              <CForm>
                <CTabs>
                  <CTab>
                    <template slot="title">
                      <CIcon name="cil-bookmark" /> Dados de Cadastro
                    </template>
                    <br />
                    <CRow>
                      <CCol md="6" sm="12">
                        <CCard>
                          <CCardBody>
                            <CInputCheckbox label="PROAP" required v-show="camposService.proap" autocomplete="email"
                              invalid-feedback="Email é obrigatório" :checked="consulta.checkProap"
                              @click="checkProapFunction">
                              <template #append-content>
                                <CIcon name="cil-at" />
                              </template>
                            </CInputCheckbox>
                            <CSelect :value.sync="pacienteSelecionado" :options="pacientes"
                              v-show="camposService.paciente" v-model="consulta.nome" prepend="PACIENTE"
                              invalid-feedback="Nome é obrigatório" @change="selecionaPaciente" disabled>
                              <template #append-content>
                                <CIcon name="cil-badge" />
                              </template>
                            </CSelect>
                            <CInput v-model="consulta.email" prepend="EMAIL" v-show="camposService.email"
                              autocomplete="email" invalid-feedback="Email é obrigatório" disabled>
                              <template #append-content>
                                <CIcon name="cil-at" />
                              </template>
                            </CInput>
                            <CInput v-model="consulta.telefone" v-show="camposService.telefone" prepend="TELEFONE"
                              invalid-feedback="Telefone Contato é obrigatório" disabled>
                              <template #append-content>
                                <CIcon name="cil-phone" />
                              </template>
                            </CInput>
                            <CSelect :value.sync="consulta.profissional" :options="listaProfissionais"
                              v-model="consulta.profissional" v-show="camposService.profissional" prepend="PROFISSIONAL"
                              :disabled="desabilitarProfisional" invalid-feedback="Nome é obrigatório"
                              @change="alteraProfissional()">
                              <template #append-content>
                                <CIcon name="cil-badge" />
                              </template>
                            </CSelect>
                            <CInput type="date" v-model="consulta.data" prepend="DIA" v-show="camposService.data"
                              autocomplete="complemento" invalid-feedback="Convenio obrigatorio"
                              :disabled="desabilitarData" @blur="alteraDia()">
                            </CInput>
                            <CSelect type="time" :options="listaHorario" v-model="consulta.hora" prepend="HORA"
                              @change="verificaHorarioRecorrencia()" @focus.prevent="valorHoraInicial"
                              v-show="camposService.hora" :disabled="desabilitarHora">
                            </CSelect>
                            <CSelect :value.sync="salaSelecionada" :options="listaSalas" v-model="consulta.sala"
                              prepend="SALA" v-show="camposService.sala" invalid-feedback="Nome é obrigatório"
                              @change="selecionaSala" :disabled="desabilitarSala">
                              <template #append-content>
                                <CIcon name="cil-badge" />
                              </template>
                            </CSelect>
                            <CInput v-model="consulta.andar" prepend="ANDAR" autocomplete="nome"
                              v-show="camposService.andar" disabled>
                              <template #append-content>
                                <CIcon name="cil-bank" />
                              </template>
                            </CInput>

                            <CSelect :options="tempoConsulta" required v-model="consulta.tempo_consulta" prepend="TEMPO"
                              v-show="camposService.tempo" placeholder=" " autocomplete="complemento"
                              invalid-feedback="Convenio obrigatorio" @change="changeTempo()" :disabled="desabilitaTempo">
                              >
                            </CSelect>
                            <CInput v-model="consulta.valorMulta" prepend="MULTA" required autocomplete="nome"
                              v-show="showInputMulta">
                              <template #append-content>
                                <CIcon name="cil-bank" />
                              </template>
                            </CInput>
                            <CInput v-model="consulta.valor" prepend="VALOR" @input="formatValue()" type="number" required
                              ref="valor" v-show="showValue" autocomplete="nome" :disabled="desabilitaValorConsulta"
                              @blur="changeValorFinanceiro()" @focus="focusValorConsulta">
                              <template #append-content>
                                <CIcon name="cil-bank" />
                              </template>
                            </CInput>
                          </CCardBody>
                        </CCard>
                      </CCol>
                      <CCol md="6" sm="12" v-show="camposService.convenio_escopo">
                        <CCard>
                          <CCardBody>
                            <h3 class="h3-convenio">Convênio</h3>
                            <CRow>
                              <CCol col="12">
                                <CSelect :options="tipoConvenio" v-model="consulta.id_convenio" required
                                  prepend="CONVÊNIO" :disabled="convenioDesabilitado"
                                  invalid-feedback="Nome é obrigatório" @change="selecionaConvenio" placeholder=" ">
                                  <template #append-content>
                                    <CIcon name="cil-badge" />
                                  </template>
                                </CSelect>
                              </CCol>
                              <CCol md="6" sm="12">
                                <CInput required v-model="consulta.numGuia" prepend="NUM. GUIA 1"
                                  invalid-feedback="Email é obrigatório" :disabled="inicio_fim_convenio">
                                  <template #append-content>
                                    <CIcon name="cil-at" />
                                  </template>
                                </CInput>
                              </CCol>
                              <CCol md="6" sm="12">
                                <CInput type="date" required v-model="consulta.dataGuia1" prepend="DATA GUIA 1"
                                  :disabled="inicio_fim_convenio">
                                </CInput>
                              </CCol>

                              <CCol md="6" sm="12">
                                <CInput required v-model="consulta.numGuia2" prepend="NUM. GUIA 2" v-show="showGuia2"
                                  invalid-feedback="Email é obrigatório" :disabled="inicio_fim_convenio">
                                  <template #append-content>
                                    <CIcon name="cil-at" />
                                  </template>
                                </CInput>
                              </CCol>

                              <CCol md="6" sm="12">
                                <CInput type="date" required v-model="consulta.dataGuia2" prepend="DATA GUIA 2"
                                  v-show="showGuia2" :disabled="inicio_fim_convenio">
                                </CInput>
                              </CCol>

                              <div>
                                <CInput v-if="protocolo" type="text" v-model="consulta.protocolo" prepend="PROTOCOLO"
                                  :disabled="inicio_fim_convenio">
                                  <template #append-content>
                                    <CIcon name="cil-at" />
                                  </template>
                                </CInput>
                            
                                <CInput v-if="protocolo" type="text" v-model="consulta.protocolo2" prepend="PROTOCOLO 2"
                                  :disabled="inicio_fim_convenio">
                                  <template #append-content>
                                    <CIcon name="cil-at" />
                                  </template>
                                </CInput>
                                <div>
                                  <CInput type="date" required v-model="consulta.chargeDateProtocol"
                                    prepend="DATA COBRANÇA" autocomplete="complemento"
                                    invalid-feedback="Convenio obrigatorio" :disabled="inicio_fim_convenio"
                                    v-show="protocolo">
                                  </CInput>
                                </div>
                              </div>
                            </CRow>
                          </CCardBody>
                        </CCard>
                      </CCol>
                    </CRow>
                    <CAlert color="warning" id="sucesso" name="sucesso" :show.sync="aviso" closeButton>{{ mensagem }}
                    </CAlert>
                    <CButton color="success" v-show="vshowAtualizar" class="m-2" @click="onSubmit()"
                      v-if="query != 'integration'">Atualizar</CButton>
                    <CButton color="info" class="m-2" @click="voltar()">Voltar</CButton>
                    <CButton color="success" v-show="vshowAtualizar" class="m-2" @click="atualizarIntegracao()"
                      v-if="query == 'integration'">Atualizar Integração</CButton>
                  </CTab>
                  <CTab v-show="abaFinantial">
                    <template slot="title">
                      <CIcon name="cil-bookmark" />
                      Financeiro
                    </template>
                    <br />
                    <CModal :show.sync="showAlteraProximaConsulta" :no-close-on-backdrop="true" :centered="true"
                      title="ALTERAR PRÓXIMA CONSULTA ?" color="warning">
                      <CAlert color="warning" id="sucesso" name="sucesso" :show.sync="avisoData" closeButton>{{ mensagem
                      }}</CAlert>
                      <CSelect :value.sync="selectAlteraConsulta" :options="[
                        { label: 'SIM', value: 1 },
                        { label: 'NÃO', value: 0 },
                      ]" required invalid-feedback="Nome é obrigatório" @change="changeSelectAlteraConsulta">
                        <template #append-content>
                          <CIcon name="cil-badge" />
                        </template>
                      </CSelect>
                      <div v-show="proximaConsultaShow">
                        <CInput type="date" v-model="valoresConsultaAlterada.dia" prepend="DIA" autocomplete="complemento"
                          invalid-feedback="Convenio obrigatorio">
                        </CInput>
                        <CInput type="time" v-model="valoresConsultaAlterada.hora" prepend="HORA">
                        </CInput>
                        <CButton @click="alteraConsulta()" color="success" class="m-2">Cadastrar</CButton>
                        <CButton color="info" class="btnVoltar" @click="voltar()">Voltar</CButton>
                      </div>
                    </CModal>
                    <CModal :show.sync="temAdintamentoFinanceiro" :no-close-on-backdrop="true" :centered="true"
                      title="Adiantamento" color="warning">
                      <h2>Consulta com adiantamento</h2>
                      <h2>Avisar administrativo !</h2>
                    </CModal>
                    <CForm @submit="salvaFinanceiro()">
                      <CRow>
                        <CCol col="12">
                          <div v-if="[1, 6, 9].includes(financeiro.convenio)">
                            <CInputCheckbox label="Adiantamento" :checked="financeiro.adiantamento"
                              :disabled="disabledCheckBoxAdiantamento" @click="mudaAdiantamento()">
                              <template #append-content>
                                <CIcon name="cil-at" />
                              </template>
                            </CInputCheckbox>
                            <div v-if="financeiro.adiantamento && financeiro.creat_at">
                              <span class="color-c3">Informações de adiantamento atualizadas no dia </span><span
                                class="color-222">{{ financeiro.creat_at }}</span>
                            </div>
                          </div>
                          <CInput v-model="financeiro.tipoServico" prepend="SERVIÇO" required disabled>
                            <template #append-content>
                              <CIcon name="cil-badge" />
                            </template>
                          </CInput>

                          <CSelect :value.sync="financeiro.convenio" v-model="financeiro.convenio" :options="tipoConvenio"
                            prepend="CONVÊNIO" :disabled="disabledConvenio" @change="changeInsurance()" required
                            placeholder=" ">
                            <template #append-content>
                              <CIcon name="cil-badge" />
                            </template>
                          </CSelect>
                          <CSelect :value.sync="presenceSelecionada" :options="optionsPresence"
                            v-model="financeiro.compareceu" prepend="COMPARECEU" @change="selecionaCompareceu()"
                            :disabled="disabledCompareceu">
                            <template #append-content>
                              <CIcon name="cil-badge" />
                            </template>
                          </CSelect>
                          <section class="radios-nf" v-show="mostrarRadiosMulta">
                            <div class="div-check-multa">
                              <p>APLICAR MULTA</p>
                            </div>
                            <div class="div-check-multa-div">
                              <input type="radio" id="um" value="SIM" @click="showFieldsYes"
                                v-model="financeiro.checkMulta" />
                              <label for="um" class="radios-multa-check">SIM</label>
                            </div>
                            <div class="div-check-multa-div">
                              <input type="radio" id="dois" value="NAO" @click="showFieldsNo"
                                v-model="financeiro.checkMulta" />
                              <label for="dois" class="radios-multa-check">NÃO</label>
                            </div>
                          </section>
                          <CSelect :value.sync="financeiro.formaPagamento" :options="formaPagamento"
                            v-model="financeiro.formaPagamento" prepend="PAGAMENTO" required :disabled="disabledPayment"
                            v-show="mostraFormaPagamento" @change="selecionaFormaPagamento()" placeholder=" ">
                            <template #append-content>
                              <CIcon name="cil-badge" />
                            </template>
                          </CSelect>
                          <CInput type="date" v-model="financeiro.datePayment" prepend="DATA PGTO"
                            v-show="dataPagamentoShow" :disabled="datePaymentDisabled" />

                          <CInput v-model="financeiro.valorMulta" prepend="MULTA" v-show="mostraMulta">
                            <template #append-content>
                              <CIcon name="cil-badge" />
                            </template>
                          </CInput>

                          <CInput v-show="showValue" v-model="financeiro.valor" prepend="VALOR" required disabled>
                            <template #append-content>
                              <CIcon name="cil-badge" />
                            </template>
                          </CInput>
                          <CInput v-show="showCoparticipacao" v-model="financeiro.coparticipacao" prepend="COPARTICIPAÇÃO"
                            v-mask="'R$: ##,00'">
                            <template #append-content>
                              <CIcon name="cil-badge" />
                            </template>
                          </CInput>
                          <section class="section-copart" v-show="showCheckCopart">
                            <div class="section-check">
                              <p>PAG.Copart</p>
                              <div class="radio_button">
                                <input type="radio" id="um" value="SIM" @click="selectCopTrue"
                                  v-model="financeiro.checkCopart" />
                                <label style="margin-left: 0.5vw" for="um" class="radios-nf-check">SIM</label>
                              </div>
                              <div style="margin-left: 1vw" class="section-copart-div-two">
                                <input type="radio" id="dois" value="NAO" @click="selectCopFalse"
                                  v-model="financeiro.checkCopart" />
                                <label style="margin-left: 0.5vw" for="dois" class="radios-nf-check">NÃO</label>
                              </div>

                              <div class="section-check-select">
                                <CSelect :value.sync="financeiro.formPagamentoCopart" :options="formPagamentoCopart"
                                  v-model="financeiro.formPagamentoCopart" v-show="showSelectCopart" prepend="PAGAMENTO"
                                  placeholder="NÃO INFORMADO">
                                  <template #append-content>
                                    <CIcon name="cil-badge" />
                                  </template>
                                </CSelect>
                              </div>
                            </div>
                          </section>

                          <CButton type="submit" v-show="vshowAtualizar" color="success" class="m-2">Proximo</CButton>
                          <CButton color="info" class="m-2" @click="voltar()">Voltar</CButton>
                        </CCol>
                      </CRow>
                    </CForm>
                  </CTab>
                  <CTab id="tab_evolucao" :disabled="desabilitarTabEvolucao" ref="evolucaoTab">
                    <template slot="title">
                      <CIcon name="cil-bookmark" /> Evolução
                    </template>
                    <br />
                    <div class="div-flex-d">
                      <div class="div-flex">
                        <input v-if="mostrarInputImagemIvolucao" style="margin-left: 10px" type="file" id="fileinput"
                          multiple ref="files" :disabled="disabledImgEvolution" @change="imputFile()" />

                        <div class="imagem-evolucao" v-show="!imagemVisivel">
                          <div class="d-flex">
                            <img v-for="(item, index) of consulta.imagem" :key="index" :src="item.img" alt="" />
                          </div>
                          <CButton @click="removerImagem()" color="info" class="mt-2 btnVoltar">Remover</CButton>
                          <CButton @click="voltar()" color="info" class="mt-2">Voltar</CButton>
                        </div>
                      </div>
                      <div class="ckeditor">
                        <ckeditor :editor="editor" v-model="editorData" :config="editorConfig" @input="inputCkEditor()"
                          :disabled="disabledTextEvolution"></ckeditor>
                      </div>
                    </div>
                    <div v-show="imagemVisivel">
                      <CButton @click="onUpload()" color="success" class="m-2">Finalizar</CButton>
                      <CButton color="info" class="m-2" @click="voltar()">Voltar</CButton>
                    </div>
                  </CTab>
                </CTabs>
              </CForm>
            </CCardBody>
            <CModal :show.sync="temRecorrenciaTempo" :no-close-on-backdrop="true" :centered="true"
              title="Deseja alterar as consultas recorrentes ?" color="warning">
              <CButton @click="atualizaConsultaModal()" color="info">Não, somente essa</CButton>
              <CButton style="margin-left: 0.5em" @click="atualizarConsultaRecorrente()" color="success">Simaaaa</CButton>
            </CModal>
            <CModal :show.sync="temRecorrencia" :no-close-on-backdrop="true" :centered="true"
              @update:show="fechaModalHora" title="Deseja alterar as consultas recorrentes ?" color="warning">
              <CButton @click="atualizaConsultaModal()" color="info">Não, somente essa</CButton>
              <CButton style="margin-left: 0.5em" @click="atualizarConsultaRecorrente()" color="success">Sim</CButton>
            </CModal>
            <CModal :show.sync="temRecorrenciaValor" :no-close-on-backdrop="true" :centered="true"
              title="Deseja alterar as consultas recorrentes ?" color="warning">
              <CButton @click="atualizaConsultaModal()" color="info">Não, somente essa</CButton>
              <CButton style="margin-left: 0.5em" @click="atualizaConsultaModalValor()" color="success">Sim</CButton>
            </CModal>
            <CModal :show.sync="temRecorrenciaData" :no-close-on-backdrop="true" @update:show="fechaModalData"
              :centered="true" title="Deseja alterar as consultas recorrentes ?" color="warning">
              <CButton @click="atualizaConsultaModalData()" color="info">Não, somente essa</CButton>
              <CButton style="margin-left: 0.5em" @click="atualizaConsultaModalDataRecorrencia()" color="success">Sim
              </CButton>
            </CModal>
            <CModal :show.sync="loginTextoEvolucao" :no-close-on-backdrop="true" :centered="true"
              title="Insira seus dados de acesso" color="info">
              <CAlert :color="colorAlertaTextoEvolucao" id="aviso" name="sucesso" :show.sync="alertaAvisoEvolucao"
                closeButton>{{ mensagemAlertaTextoEvolucao }}</CAlert>
              <CInput type="text" v-model="username" prepend="EMAIL" autocomplete="complemento"
                invalid-feedback="Convenio obrigatorio">
                <template #append-content>
                  <CIcon name="cil-contact" />
                </template>
              </CInput>

              <CInput prepend="Senha" type="password" v-model="password" autocomplete="complemento"
                invalid-feedback="* Campo obrigatorio">
              </CInput>

              <CButton @click="recuperaTextEvolutionModal()" color="success">Enviar</CButton>
              <CButton style="margin-left: 0.5em" @click="atualizaConsultaModalValor()" color="info">Voltar</CButton>
            </CModal>
            <CModal class="modalPerfil" :show.sync="modalDataOcupada" :no-close-on-backdrop="true" :centered="true"
              title="Modal title 2" :color="corModal ? corModal : 'warning'">
              <CAlert :color="colorAlertaAviso" id="aviso" name="sucesso" :show.sync="alertaAviso" closeButton>{{ mensagem
              }}
              </CAlert>
              <table>
                <tr></tr>
                <tr v-for="elem of consultasRecorrentesValidacao" :key="elem.id">
                  <div v-if="elem.error == 'profissional_ocupation' ||
                    elem.error == 'sala_ocupation'
                    ">
                    <td>
                      <div>
                        <CInput class="inline_block input_modal" type="date" required v-model="elem.dataModal"
                          autocomplete="complemento" invalid-feedback="Convenio obrigatorio" disabled>
                        </CInput>

                        <CInput class="inline_block input_modal" type="time" v-model="elem.hora" required></CInput>
                        <CButton class="inline_block" @click="salvarConsultaModal(elem)" color="info">Salvar</CButton>
                        <CIcon :height="42" name="cil-check-alt" class="icon-item" v-if="elem.horaConflito == false" />
                        <p class="ocupado" v-if="elem.horaConflito == true">X</p>
                      </div>
                      <p class="p_message">{{ elem.message }}</p>
                    </td>
                  </div>
                </tr>
                <td>
                  <CButton v-if="btnAtualizarConsultas == true" class="inline_block"
                    @click="AtualizarConsultasComRecorrencia()" color="success">Atualizar</CButton>
                </td>
              </table>

              <template #header>
                <h4 class="modal-title">
                  {{ mensagemModal }}
                </h4>
                <CButtonClose @click="cancelarmodalDataOcupada()" class="text-white" />
              </template>
            </CModal>
          </CCard>
        </div>
        <CAlert color="warning" id="aviso" name="sucesso" :show.sync="errAdiantamento" closeButton>{{ mensagem }}</CAlert>
        <CAlert color="success" id="aviso" name="sucesso" :show.sync="sucesso" closeButton>{{ mensagem }}</CAlert>
        <CModal :show.sync="temGuia" :no-close-on-backdrop="true" :centered="true"
          title="Deseja sobrescrever as guias da proxima consulta ?" color="warning">
          <!-- code ... -->
          <h4>
            Transferir guia do dia {{ formattedDataConsulta }} para a consulta do dia
            {{ guiaProximaConsulta.dataProximaConsulta }}
          </h4>
          <div>
            <CDataTable :fields="fieldTableModalGuia" :items="[
              {
                guia: this.consulta.numGuia,
                data: this.consulta.dataGuia1,
              },
              {
                guia: this.consulta.numGuia2,
                data: this.consulta.dataGuia2 == null ? '' : this.consulta.dataGuia2,
              },
            ]"></CDataTable>
          </div>
          <CButton class="inline_block" @click="sobrescreverGuia()" color="success">Sim</CButton>
          <CButton class="inline_block" @click="cancelaModalGuia()" color="info">Não</CButton>
        </CModal>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import moment from "moment";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "PerfilConsultas",

  data() {
    return {
      datePaymentDisabled: false,
      temRecorrenciaTempo: false,
      colorAlertaTextoEvolucao: "",
      mensagemAlertaTextoEvolucao: "",
      username: "",
      password: "",
      loginTextoEvolucao: false,
      disabledTextEvolution: false,
      disabledImgEvolution: false,
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        toolbar: ["bold", "italic", "link", "undo", "redo"],
      },
      showCoparticipacao: false,
      showCheckCopart: false,
      customModal: false,
      desabilitaValorConsulta: true,
      showModalFinanceiro: false,
      desabilitarSomar: true,
      dataPagamentoShow: false,
      mask: "",
      cpf: "###.###.###-##",
      telefone: "(##) #####.####",
      cep: "#####-###",
      senha: false,
      sucesso: false,
      aviso: false,
      alertPessoa: false,
      mostraMulta: false,
      selectedFile: null,
      evoDisabled: false,
      btn_financial_disabled: true,
      desabilitarCheckBoxModal: true,
      dataModal: "",
      textArea: "",
      vshowprotocolo: true,
      validacoes: {
        sucesso: false,
        aviso: false,
        msg: "",
        statusData: "",
        statusHora: "",
      },
      vshowAtualizar: false,
      mostrarRadiosMulta: false,
      disabledPayment: false,
      optFinatial: [],
      formaPagamento: [
        { label: "NÃO PAGOU", value: "nao_pagou" },
        { label: "DINHEIRO", value: "dinheiro" },
        { label: "CONVÊNIO", value: "convenio" },
        { label: "PIX", value: "pix" },
        { label: "ISENTO", value: "isento" },
      ],
      listaPagamentosModal: [
        { label: "Dinheiro", value: "dinheiro" },

        { label: "Pix", value: "pix" },
      ],
      pagamentoModalSelecionado: "",
      formPagamentoCopart: [
        {
          label: "PIX",
          value: 1,
        },
        {
          label: "DINHEIRO",
          value: 2,
        },
      ],
      optionsPresence: [
        { label: "SIM", value: 1 },
        { label: "NÃO", value: 2 },
        { label: "NÃO INFORMADO", value: 3 },
      ],
      presenceSelecionada: "",
      avisoData: false,
      showProximaConsulta: false,
      showAlteraProximaConsulta: false,

      financeiro: {
        compareceu: "",
        tipoServico: "",
        formaPagamento: "",
        valor: "",
        valorMulta: 0,
        convenio: "",
        idPaciente: "",
        idProfissional: "",
        checkMulta: "",
        idConsulta: "",
        evolution: "",
        protocol: "",
        coparticipacao: 0,
        checkCopart: "",
        formPagamentoCopart: "",
        datePayment: "",
        adiantamento: false,
        creat_at: "",
        copyAdiantamento: false,
        isDateConsultSameDateToday: false,
        dataConsulta: null,
      },

      valoresConsultaAlterada: {
        id: "",
        dia: "",
        hora: "",
      },
      selectAlteraConsulta: 0,
      tipoConvenio: [],
      mensagem: "",
      disabledCompareceu: false,
      disabledConvenio: false,
      inicio_fim_convenio: false,
      protocolo: false,
      showSelectCopart: false,
      //Campos visiveis
      camposService: {
        proap: false,
        paciente: false,
        email: false,
        telefone: false,
        profissional: false,
        sala: false,
        andar: false,
        data: false,
        cpf: false,
        tempo: false,

        hora: false,
        valor: false,
        convenio_escopo: false,

        consultasData: [],
      },
      temAdintamentoFinanceiro: false,
      // Consultas

      tempoConsulta: [
        { label: "25 minutos", value: 0.5 },
        { label: "50 minutos", value: 1 },
      ],
      dadosConsulta: {
        sala: "",
        hora: "",
        data: "",
        profisional: "",
      },
      imagemVisivel: false,
      showGuia2: true,
      consulta: {
        checkProap: "",
        id: "",
        patient: "",
        nome: "",
        telefone: "",
        email: "",
        profissional: "",
        data: "",
        data_inicial: "",
        tempo_consulta: "",
        aux_tempo_consulta: "",
        hora: "",
        aux_hora: "",
        imagem: [],
        sala: "",
        andar: "",
        numGuia: "",
        valorMulta: "0",
        valor: "",
        id_convenio: "",
        chargeDateProtocol: "",
        data_final: null,
        protocolo: "",
        protocolo2: "",
        numGuia: "",
        imagemEvolution: "",
        statusConsulta: "",
        dataGuia1: "",
        numGuia2: "",
        dataGuia2: "",
        statusconsulta: "",
        data_inicio: "",
        data_final: "",
      },
      estadoInicial: {},
      atributosMudados: {},
      arrDebitos: [],

      ShowUser: false,
      ShowUserEvolution: false,
      paramVoltar: 0,

      //tipo serviço
      option: "",
      //profissional
      listaProfissionais: [],
      profissionalSelecionado: "",
      //paciente
      listaPaciente: [],
      pacientes: [],
      pacienteSelecionado: "",
      dadosPaciente: {
        email: "",
        telefone: "",
      },
      //sala
      salas: [],
      listaSalas: [],
      salaSelecionada: "",
      dadosSala: {
        andar: "",
      },
      abaFinantial: false,
      //modal
      darkModal: false,
      showModal: false,
      showInputMulta: false,
      showValue: true,
      multa: "",
      fields: [
        {
          key: "date_at",
          label: "Data da consulta",
          _style: "min-width:100px",
        },
        { key: "hour_at", label: "Hora", _style: "min-width:20px;" },
        { key: "name", label: "Profissional", _style: "min-width:170px;" },
        { key: "multa", label: "Valor", _style: "min-width:40px;" },

        {
          key: "acao",
          label: "",
          sorter: false,
          filter: false,
        },
      ],
      proximaConsultaShow: false,
      dadosPacienteMulta: [],
      selectedFile: null,
      selectNovaConsulta: 0,
      idPatient: "",
      validate_presence: false,
      desabilitarData: false,
      desabilitarHora: false,
      desabilitarTabEvolucao: false,
      countModal: 0,
      controllerModal: false,
      controllerCountModal: 1,
      resMulta: 0,

      showAdiantamento: false,
      mostraFormaPagamento: true,
      disabledCheckBoxAdiantamento: false,
      temRecorrencia: false,
      consultasRecorrentes: [],
      consultasRecorrentesValidacao: [],
      alertaAviso: false,
      modalDataOcupada: false,
      consultasData: [],
      colorAlertaAviso: "",
      btnAtualizarConsultas: false,
      consultaComHorarioConflito: "",
      horaAuxiliar: "",
      valorAuxiliarConsulta: "",
      temRecorrenciaValor: false,
      campoRecorrencia: "",
      temGuia: false,
      query: "",
      guiaProximaConsulta: [],
      fieldTableModalGuia: [
        {
          key: "guia",
          label: "Guia",
          _style: "min-width:100px",
        },
        { key: "data", label: "Data", _style: "min-width:20px;" },
      ],

      listaHorario: [
        { label: "07:00", value: "07:00" },
        { label: "07:30", value: "07:30" },
        { label: "08:00", value: "08:00" },
        { label: "08:30", value: "08:30" },
        { label: "09:00", value: "09:00" },
        { label: "09:30", value: "09:30" },
        { label: "10:00", value: "10:00" },
        { label: "10:30", value: "10:30" },
        { label: "11:00", value: "11:00" },
        { label: "11:30", value: "11:30" },
        { label: "12:00", value: "12:00" },
        { label: "12:30", value: "12:30" },
        { label: "13:00", value: "13:00" },
        { label: "13:30", value: "13:30" },
        { label: "14:00", value: "14:00" },
        { label: "14:30", value: "14:30" },
        { label: "15:00", value: "15:00" },
        { label: "15:30", value: "15:30" },
        { label: "16:00", value: "16:00" },
        { label: "16:30", value: "16:30" },
        { label: "17:00", value: "17:00" },
        { label: "17:30", value: "17:30" },
        { label: "18:00", value: "18:00" },
        { label: "18:30", value: "18:30" },
        { label: "19:00", value: "19:00" },
        { label: "19:30", value: "19:30" },
        { label: "20:00", value: "20:00" },
        { label: "20:30", value: "20:30" },
        { label: "21:00", value: "21:00" },
      ],
      alertaAvisoEvolucao: false,
      showBtnLer: false,
      mostrarInputImagemIvolucao: true,
      mensagemModal: null,
      corModal: "success",
      temRecorrenciaData: false,
      errAdiantamento: false,
      convenioDesabilitado: false,
      dataAlteradaBlur: "",
      dataInicialBlur: "",
      horarioAlterado: "",
      desabilitarProfisional: false,
      desabilitaTempo: false,
      desabilitarSala: false,
    };
  },

  methods: {
    formatValue() {

      if (this.consulta.valor) {
        let numericValue = this.consulta.valor.replace(/[^0-9,]/g, "");
        numericValue = parseInt(numericValue.replace(",", "."), 10);
        if (!isNaN(numericValue)) {
          const formattedNumber = numericValue / 100;
          const numeroFormatado = formattedNumber.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });


          this.consulta.valor = numeroFormatado.slice(3).replace(",", ".");


        } else {
          this.consulta.valor = "";
        }
      }
    },
    cancelarmodalDataOcupada() {
      this.modalDataOcupada = false;
    },
    recuperaTextEvolutionModal() {
      if (this.username == "") {
        this.alertaAvisoEvolucao = true;
        this.colorAlertaTextoEvolucao = "warning";
        this.mensagemAlertaTextoEvolucao = "Necessario o Email de acesso";
      } else if (this.password == "") {
        this.alertaAvisoEvolucao = true;
        this.colorAlertaTextoEvolucao = "warning";
        this.mensagemAlertaTextoEvolucao = "Necessario o Senha de acesso";
      }

      if (this.username != "" && this.password != "") {
        this.$http
          .post(`${process.env.VUE_APP_API_BASE_URL}consulta/evolucao/login`, {
            id: this.consulta.id,
            user: this.username,
            password: this.password,
          })
          .then((res) => res.json())
          .then((res) => {
            this.alertaAvisoEvolucao = true;
            this.colorAlertaTextoEvolucao = "success";
            this.mensagemAlertaTextoEvolucao = "Usuario autorizado";

            setTimeout(() => {
              this.alertaAvisoEvolucao = false;
              this.loginTextoEvolucao = false;
              this.$http
                .get(
                  `${process.env.VUE_APP_API_BASE_URL}consulta/text-evolucao/${this.consulta.id}`
                )
                .then((res) => res.json())
                .then((res) => {
                  this.editorData = res.message;
                  this.showBtnLer = false;
                });
            }, 1000);
          })
          .catch((err) => {
            this.alertaAvisoEvolucao = true;
            this.colorAlertaTextoEvolucao = "warning";
            this.mensagemAlertaTextoEvolucao = "Usuario ou senha incorretos";
          });
      }
    },
    recuperaTextEvolution() {
      this.loginTextoEvolucao = true;
    },
    inputCkEditor() {
      if (this.editorData) {
        this.disabledImgEvolution = true;
      } else {
        this.disabledImgEvolution = false;
      }
    },

    formaPagamentoModal() {
      this.desabilitarCheckBoxModal = false;
    },
    voltar() {
      if (!this.paramVoltar) this.paramVoltar = 0;
      if (this.paramVoltar != 0) {
        this.$router.push(this.paramVoltar);
        this.paramVoltar = 0;
      } else {
        history.back();
        // this.$router.push("/consultas");
      }
    },
    changeValorFinanceiro() {
      this.financeiro.valor = this.consulta.valor;
      this.consulta.valor = parseFloat(this.consulta.valor).toFixed(2);

      if (this.valorAuxiliarConsulta == this.consulta.valor) {
      } else {
        this.verificaRecorrencia().then((res) => {
          if (res.consultas.length > 1) {
            this.temRecorrenciaValor = true;
            this.campoRecorrencia = "valor_consulta";
          }
        });
      }
    },
    atualizaConsultaModalValor() {
      if (this.campoRecorrencia == "tempo_consulta") {
        this.$http
          .post(
            `${process.env.VUE_APP_API_BASE_URL}atualiza-tempo-recorrencia`,
            this.consulta
          )
          .then((res) => {
            this.temRecorrenciaValor = false;
          });
      }
      if (this.campoRecorrencia == "valor_consulta") {
        this.$http
          .post(
            `${process.env.VUE_APP_API_BASE_URL}atualiza-valor-recorrencia`,
            this.consulta
          )
          .then((res) => {
            this.temRecorrenciaValor = false;
          });
      }
      if (this.campoRecorrencia == "convenio_consulta") {
        this.$http
          .post(
            `${process.env.VUE_APP_API_BASE_URL}atualiza-convenio-recorrencia`,
            this.consulta
          )
          .then((res) => {
            this.temRecorrenciaValor = false;
          });
      }
    },
    listarConvenio() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}convenios-instancia`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((elem) => {
            if (elem.name != "Coparticipação Saúde Pas") {
              this.tipoConvenio.push({
                label: elem.name,
                value: elem.id,
              });
            }
          });
        });
    },

    listarConsultas(id) {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}consultas/${id}`)
        .then((res) => res.json())
        .then((res) => {
          
          const resultado = {
            typeUser: localStorage.getItem("type_name"),
            tipoConvenio: res[0].id_insurance,
            checkMulta: res[0].check_multa,
            compareceu: res[0].presence,
          };
          this.verificaStatusMulta(resultado);

          this.disabledConvenio = res[0].idservice === 2 ? true : false;
          if (this.disabledConvenio) {
            this.formaPagamento = this.formaPagamento.filter(
              (elem) => elem.value !== "convenio"
            );
          }

          res[0].presence == null
            ? (this.financeiro.compareceu = 3)
            : (this.financeiro.compareceu = parseInt(res[0].presence));

          if (res[0].statusconsulta == "Cancelada") {
            this.ShowUser = false;
            this.vshowAtualizar = false;
          } else {
            this.ShowUser = true;
            this.vshowAtualizar = true;
          }

          this.option = res[0].idservice;
          this.tipoServico();

          this.consulta.sala = res[0].sala;

          let dataAtual = moment.utc().format("YYYY/MM/DD");
          let dataCadastrada = moment.utc(res[0].date_at).format("YYYY/MM/DD");
          this.dataInicialBlur = moment.utc(res[0].date_at).format("YYYY/MM/DD");
          this.financeiro.user = localStorage.getItem("type_name");

          let tipoUser = localStorage.getItem("type_name");

          if (dataAtual >= dataCadastrada) {
            this.disabledCheckBoxAdiantamento = true;
            this.financeiro.isDateConsultSameDateToday = true;
          } else {
            this.disabledCheckBoxAdiantamento = false;
            this.financeiro.isDateConsultSameDateToday = false;
          }

          if (res[0].statusconsulta == "Evolucao" && dataAtual == dataCadastrada) {
            this.desabilitarTabEvolucao = false;
          } else {
            this.desabilitarTabEvolucao = true;
          }

          this.consulta.data_inicio = moment.utc(res[0].start_date).format("YYYY-MM-DD");
          this.consulta.data_final = moment.utc(res[0].end_date).format("YYYY-MM-DD");
          this.consulta.protocolo = res[0].protocol;

          if (res[0].protocol) {
            this.financeiro.protocol = "Preenchido";
          }
          this.idPatient = res[0].id_patient;
          this.consulta.id = res[0].id;
          this.consulta.nome = res[0].id_patient;
          this.consulta.patient = res[0].id_patient;
          this.consulta.email = res[0].email;
          this.consulta.data = moment.utc(res[0].date_at).format("YYYY-MM-DD");
          this.consulta.data_inicial = moment.utc(res[0].date_at).format("YYYY-MM-DD");
          this.consulta.hora = res[0].hour_at;
          this.consulta.aux_hora = res[0].hour_at;
          this.horarioAlterado = res[0].hour_at;
          this.consulta.telefone = res[0].telefone;
          this.consulta.numGuia = res[0].numeroguia;
          this.consulta.valor = res[0].valor;
          this.consulta.profissional = res[0].id_professional;
          this.consulta.sala = res[0].sala;
          this.consulta.andar = res[0].andar;
          this.consulta.statusConsulta = res[0].statusconsulta;
          let user = localStorage.getItem("type_name");
          this.consulta.statusconsulta = res[0].statusconsulta;
          this.consulta.protocolo2 = res[0].protocolo2;
          if (user == "Profissional") {
            if (
              this.consulta.statusconsulta == "Sem Guia" ||
              this.consulta.statusconsulta == "Sem Protocolo"
            ) {
              this.consulta.statusconsulta = "-";
            }
          }
          res[0].statusconsulta != "Evolucao"
            ? (this.desabilitarTabEvolucao = true)
            : (this.desabilitarTabEvolucao = false);
          this.consulta.id_convenio = res[0].id_insurance;
          this.consulta.checkProap = res[0].proap == "1" ? true : false;
          this.consulta.tempo_consulta = parseFloat(res[0].consult_time);
          if (this.consulta.tempo_consulta != 1) {
            this.showGuia2 = false;
          }
          this.consulta.imagemEvolution = res[0].nameimgevolution;
          if (this.consulta.imagemEvolution) {
            this.mostrarInputImagemIvolucao = false;
            this.disabledTextEvolution = true;
          }

          this.editorData = res[0].evolution_text ? res[0].evolution_text : "";
          this.consulta.dataGuia1 = res[0].dataguia1
            ? moment.utc(res[0].dataguia1).format("YYYY-MM-DD")
            : null;
          this.consulta.numGuia2 = res[0].numguia2;
          this.consulta.dataGuia2 = res[0].dataguia2
            ? moment.utc(res[0].dataguia2).format("YYYY-MM-DD")
            : null;
          this.consulta.chargeDateProtocol = res[0].charge_date_protocol;
          this.dadosConsulta.sala = res[0].sala;
          this.dadosConsulta.hora = res[0].hour_at;
          this.dadosConsulta.data = moment.utc(res[0].date_at).format("YYYY-MM-DD");
          this.dadosConsulta.profisional = res[0].id_professional;
          this.financeiro.idPaciente = res[0].id_patient;
          this.financeiro.idProfissional = res[0].id_professional;
          this.financeiro.valor = res[0].valor;
          this.financeiro.tipoServico = res[0].typeservice;
          this.financeiro.formaPagamento = res[0].paymentform;
          this.financeiro.convenio = parseInt(res[0].idconvenio);
          
          if ([1, 6, 9].includes(this.financeiro.convenio)) {
            this.formaPagamento = this.formaPagamento.filter(option => option.value !== "convenio");
          }
          this.financeiro.checkCopart = res[0].checkcopart;
          this.financeiro.formPagamentoCopart = res[0].pag_copart;
          this.financeiro.datePayment = res[0].date_payment;
          this.financeiro.checkMulta = res[0].check_multa;
          this.financeiro.valorMulta = res[0].multa;
          this.financeiro.idConsulta = res[0].id;

          this.salasDisponiveis();

          if (this.financeiro.compareceu == 2) {
            this.mostrarRadiosMulta = true;
          }

          if (res[0].adiantamento == true) {

            setTimeout(() => {
              this.datePaymentDisabled = true;
            }, 1000);
            this.financeiro.adiantamento = true;
            this.financeiro.copyAdiantamento = true;
            this.financeiro.creat_at = moment
              .utc(res[0].createatfinancial)
              .format("YYYY-MM-DD");
          }

          if (![1, 6, 9].includes(this.financeiro.convenio)) {
            if (this.financeiro.compareceu == 2) {
              this.mostrarRadiosMulta = true;
            }
            this.mostraMulta = false;
            this.dataPagamentoShow = false;
          }

          if (
            this.financeiro.checkMulta == "SIM" &&
            ![1, 6, 9].includes(this.financeiro.convenio)
          ) {
            this.mostraMulta = false;
          }

          if (res[0].coparticipacao) {
            this.financeiro.coparticipacao = res[0].coparticipacao.toLocaleString(
              "pt-br",
              {
                style: "currency",
                currency: "BRL",
              }
            );
          }

          if (
            res[0].nameimgevolution &&
            res[0].id_professional == localStorage.getItem("id")
          ) {
            this.desabilitarTabEvolucao = false;
          }
          if (res[0].nameimgevolution) {
            this.financeiro.evolution = "Preenchida";
          }

          if (!this.financeiro.tipoServico) {
            switch (res[0].idservice) {
              case 1:
                this.financeiro.tipoServico = "CONSULTA";
                break;
              case 2:
                this.financeiro.tipoServico = "AVALIAÇÃO";
                break;
              case 3:
                this.financeiro.tipoServico = "CURSO";
                break;
              case 4:
                this.financeiro.tipoServico = "PALESTRA";
                break;
            }
          }
          if (!this.financeiro.convenio) {
            this.financeiro.convenio = res[0].id_insurance;
          }
          if (res[0].paymentform == "isento" && this.financeiro.compareceu == 1) {
            this.mostraMulta = false;
          }
          if (
            res[0].paymentform != "isento" &&
            [1, 6, 7, 9].includes(this.financeiro.convenio)
          ) {
            this.dataPagamentoShow = true;
          }

          this.financeiro.formaPagamento = "convenio";
          if (res[0].paymentform) {
            this.financeiro.formaPagamento = res[0].paymentform;
          }
        })
        .then((res) => {
          if (
            this.consulta.id_convenio == 1 ||
            this.consulta.id_convenio == 6 ||
            this.consulta.id_convenio == 9
          ) {
            this.inicio_fim_convenio = true;
            this.consulta.protocolo = "";
            this.consulta.data_inicio = null;
            this.consulta.data_final = null;
            this.consulta.numGuia = "";
          } else {
            this.inicio_fim_convenio = false;
          }
          this.buscaMulta(this.consulta.nome);
          let data = new Date();
          let dataAtual = moment.utc(data).format("YYYY/MM/DD");
          let dataConsulta = moment.utc(this.consulta.data).format("YYYY/MM/DD");
          if (dataAtual == dataConsulta) {
            this.retornaNumConsulta();
          }
        })
        .then((res) => {
          let userTipo = localStorage.getItem("type_name");
          if (userTipo == "Profissional") {
            this.disabledConvenio = true;
            this.convenioDesabilitado = true;
            this.inicio_fim_convenio = true;
          }

          const isFormatoAntigo = /^[\d-]+$/.test(this.consulta.imagemEvolution);

          if (isFormatoAntigo) {
            const imagensAntigas = this.consulta.imagemEvolution
              .split(",")
              .map((name) => ({ name: name }));

            this.consulta.imagemEvolution = JSON.stringify(imagensAntigas);
          }
          const imgEvo = JSON.parse(this.consulta.imagemEvolution);

          this.recuperaImagens(imgEvo);

          if (this.financeiro.tipoServico != "AVALIAÇÃO") {
            if (
              this.financeiro.convenio == 1 ||
              this.financeiro.convenio == 6 ||
              this.financeiro.convenio == 9
            ) {
              this.disabledPayment = false;
            } else {
              this.disabledPayment = true;
            }
          } else {
            this.disabledPayment = false;
          }

          if (this.financeiro.checkMulta == "SIM" && this.financeiro.convenio == 7) {
            this.showCoparticipacao = false;
            this.dataPagamentoShow = false;
            this.showCheckCopart = false;
          }

          if (this.financeiro.adiantamento == true) {
            this.desabilitaValorConsulta = true;
          }

          this.estadoInicial = JSON.parse(JSON.stringify(this.consulta));
          this.formatValue(this.consulta.valor);
        });

      



    },
    recuperaImagens(imagens) {
      if (this.consulta.imagemEvolution == null) {
        this.imagemVisivel = true;
      } else {
        for (let i = 0; i < imagens.length; i++) {
          this.$http
            .post(`${process.env.VUE_APP_API_BASE_URL}buscar-imagem`, {
              env: this.$apiImgUrl + imagens[i].name,
            })
            .then((res) => {
              this.consulta.imagem.push({ img: res.data });
            })
            .catch((err) => { });
        }
      }
    },
    verificaStatusMulta(resultado) {
      if (resultado.typeUser !== "Profissional") {
        if (resultado.tipoConvenio !== 1 && resultado.tipoConvenio !== 6) {
          this.mostrarRadiosMulta = resultado.compareceu === "2" ? true : false;
        } else if (resultado.compareceu === "2") {
          this.mostraMulta =
            resultado.tipoConvenio === 1 || resultado.tipoConvenio === 6 ? true : false;
        }
      }
      if (resultado.compareceu !== 1) {
        this.dataPagamentoShow = false;
      }
    },
    changeInsurance() {

      // this.$http.post(`${process.env.VUE_APP_API_BASE_URL}consulta/altera/convenio`,{
      //     idConvenio: this.financeiro.convenio,
      //     idConsulta: this.financeiro.idConsulta
      // })
      if (this.financeiro.convenio == 7) {
        this.dataPagamentoShow = true;
        this.financeiro.adiantamento = false;
      } else if (![1, 6, 9].includes(this.financeiro.convenio)) {
        this.dataPagamentoShow = false;
        this.financeiro.adiantamento = false;
        this.mostrarRadiosMulta = false;
      }
      if ([1, 6, 9].includes(this.financeiro.convenio)) {
        this.formaPagamento = this.formaPagamento.filter(option => option.value !== "convenio");
        if (this.financeiro.copyAdiantamento == true) {
          this.financeiro.adiantamento = true;
        }
        this.financeiro.formaPagamento = "";
        this.disabledPayment = false;
      } else {
        this.formaPagamento.push({ label: "CONVÊNIO", value: "convenio" });
        this.financeiro.adiantamento = false;
        this.disabledPayment = true;
        this.financeiro.formaPagamento = "convenio";
      }
      if (
        (this.financeiro.convenio === 1 && this.financeiro.compareceu == 2) ||
        (this.financeiro.convenio === 6 && this.financeiro.compareceu == 2) ||
        (this.financeiro.convenio === 9 && this.financeiro.compareceu == 2)
      ) {
        this.mostraMulta = true;
      } else {
        this.mostraMulta = false;
      }
      this.habilitarCoparticapao();
    },
    tipoServico() {
      switch (this.option) {
        case 1:
          this.camposService.proap = true;
          this.camposService.paciente = true;
          this.camposService.email = true;
          this.camposService.telefone = true;
          this.camposService.profissional = true;
          this.camposService.sala = true;
          this.camposService.andar = true;
          this.camposService.data = true;
          this.camposService.tempo = true;
          this.camposService.hora = true;
          this.camposService.valor = true;
          this.camposService.convenio_escopo = true;
          break;
        case 2:
          this.camposService.proap = false;
          this.camposService.paciente = true;
          this.camposService.email = true;
          this.camposService.telefone = true;
          this.camposService.profissional = true;
          this.camposService.sala = true;
          this.camposService.andar = true;
          this.camposService.data = true;
          this.camposService.tempo = false;
          this.camposService.hora = true;
          this.camposService.valor = true;
          this.camposService.convenio_escopo = false;
          this.consulta.id_convenio = "";

          break;
        case 3:
          this.camposService.proap = false;
          this.camposService.paciente = false;
          this.camposService.email = false;
          this.camposService.telefone = false;
          this.camposService.profissional = true;
          this.camposService.sala = true;
          this.camposService.andar = true;
          this.camposService.data = true;
          this.camposService.tempo = false;
          this.camposService.hora = true;
          this.camposService.valor = true;
          this.camposService.convenio_escopo = false;
          this.consulta.id_convenio = "";
          break;
        case 4:
          this.camposService.proap = false;
          this.camposService.paciente = false;
          this.camposService.email = false;
          this.camposService.telefone = false;
          this.camposService.profissional = true;
          this.camposService.sala = false;
          this.camposService.andar = false;
          this.camposService.data = true;
          this.camposService.tempo = false;
          this.camposService.hora = true;
          this.camposService.valor = true;
          this.camposService.convenio_escopo = false;
          this.consulta.id_convenio = "";
          break;

        default:
      }
    },
    checkProapFunction() {
      this.consulta.checkProap = !this.consulta.checkProap;
    },
    listarPaciente() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}pacientes`)
        .then((res) => res.json())
        .then((res) => {
          this.listaPaciente = res;
          res.forEach((item) => {
            this.pacientes.push({
              label: item.patient.toUpperCase(),
              value: item.id,
            });
          });
        });
    },
    selecionaPaciente() {
      this.listaPaciente.forEach((paciente) => {
        if (paciente.id == this.pacienteSelecionado) {
          this.consulta.nome = paciente.patient;
          this.consulta.email = paciente.email;
          this.consulta.telefone = paciente.phone;
          this.consulta.cpf = paciente.cpf;
        }
      });
    },
    async listarSalas() {
      await this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}salas`)
        .then((res) => res.json())
        .then((res) => {
          this.salas = res;
          this.listaSalas.push({ label: "Online", value: 0 });
          res.forEach((item) => {
            this.listaSalas.push({
              label: `Sala: ${item.sala}`,
              value: item.sala,
            });
          });
        });
    },
    selecionaSala() {
      this.salas.map((elem) => {
        let sala = this.salaSelecionada;

        if (sala === 0) {
          this.consulta.andar = "-";
        } else {
          if (elem.sala === this.salaSelecionada) {
            this.consulta.andar = elem.andar;
          }
        }
      });
    },
    selecionaConvenio() {


      this.campoRecorrencia = "convenio_consulta";
      this.temRecorrenciaValor = true;
      if (
        this.consulta.id_convenio == 1 ||
        this.consulta.id_convenio == 6 ||
        this.consulta.id_convenio == 9
      ) {
        this.inicio_fim_convenio = true;
        this.protocolo = false;
        this.consulta.data_inicio = null;
        this.consulta.data_final = null;
      } else {
        this.protocolo = true;
        this.inicio_fim_convenio = false;
        this.consulta.data_inicio = new Date();
        this.consulta.data_final = new Date();
      }
    },
    listaPorfissionais() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}profissionais`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            this.listaProfissionais.push({
              label: item.name,
              value: item.id,
            });
            if (item.id == this.$route.query.id) {
              this.listaProfissionais.push({
                label: item.name,
                value: item.id,
              });
            }
          });
        });
    },
    async AtualizarConsultasComRecorrencia() {

      const temHorarioConflito = this.consultasRecorrentesValidacao.filter(
        (x) => x.horaConflito == true
      );

      if (temHorarioConflito.length > 0) {
        this.colorAlertaAviso = "warning";
        this.alertaAviso = true;
        this.mensagem = "Ainda há horarios indisponiveis";
        return;
      }

      for (let i = 0; i < this.consultasRecorrentesValidacao.length; i++) {
        const elem = this.consultasRecorrentesValidacao[i];

        this.consulta.id = elem.id;
        this.consulta.hora = elem.hora;
        this.consulta.data = elem.dataModal;
        this.consulta.sala = elem.sala;
        this.consulta.recorrencia = true;
        this.consulta.numGuia = elem.numGuia;
        this.consulta.numGuia2 = elem.numGuia2;
        this.consulta.dataGuia1 = elem.dataGuia1;
        this.consulta.dataGuia2 = elem.dataGuia2;
        this.consulta.statusconsulta = elem.statusconsulta
        await this.atualizaConsultaRecorrente();
      }

      this.modalDataOcupada = false;

      this.consulta.data = this.consultasRecorrentesValidacao[0].dataModal;
      // window.location.reload();
    },
    async atualizaConsultaRecorrente() {

      return new Promise((resolve, reject) => {
        this.$http
          .post(`${process.env.VUE_APP_API_BASE_URL}valida/tempo-consulta`, this.consulta)
          .then((res) => {
            if (res.status === 201) {
              this.message = `Sala ocupada às ${res.body.consulta.hour_at}`;
              reject(new Error(this.message));
            } else if (res.status === 203) {
              this.message = `Profissional ocupado às ${res.body.consulta.hour_at}`;
              reject(new Error(this.message));
            } else {
              return this.$http.post(
                `${process.env.VUE_APP_API_BASE_URL}valida-consulta`,
                this.consulta
              );
            }
          })
          .then((res) => {
            if (res.status === 201) {
              this.mensagem = "Horário indisponível para essa sala";
              this.message = `Sala ocupada às ${res.body.consulta.hour_at}`;
              reject(new Error(this.message));
            } else if (res.status === 203) {
              this.mensagem = "Horário indisponível para esse profissional";
              this.message = `Profissional ocupado às ${res.body.consulta.hour_at}`;
              reject(new Error(this.message));
            } else {
              return this.$http
                .post(`${process.env.VUE_APP_API_BASE_URL}consultas/atualizar-recorrencia`, {
                  consulta: this.consulta,
                })
                .then(() => {
                  this.sucesso = true;
                  this.mensagem = "Consulta alterada com sucesso";
                  setTimeout(() => {
                    this.sucesso = false;
                  }, 3000);
                  resolve(res);
                });
            }
          });
      });
    },


    async changeTempo() {
      if (this.consulta.tempo_consulta) {
        const recorrencia = await this.verificaRecorrencia();
        const { result, consultas } = recorrencia;
        if (result) {
          this.temRecorrenciaTempo = true;
          this.consultasRecorrentesValidacao = [];
          this.consultasRecorrentesValidacao.unshift({
            id: this.$route?.query?.id ? this.$route?.query?.id : "",
            data: moment.utc(this.consulta.data).format("YYYY-MM-DD"),
            dataModal: moment.utc(this.consulta.data).format("YYYY-MM-DD"),
            hora: this.consulta.hora,
            horaModal: this.consulta.hora,
            sala: this.consulta.sala,
            profissional: this.consulta.profissional,
            patient: this.consulta.patient,
            numGuia: this.consulta.numGuia,
            numGuia2: this.consulta.numGuia2,
            dataGuia1: this.consulta.dataGuia1,
            dataGuia2: this.consulta.dataGuia2,
          });


          for (let i = 0; i < consultas.length; i++) {
            this.consultasRecorrentesValidacao.push({
              id: consultas[i].id,
              data: moment.utc(consultas[i].date_at).format("YYYY-MM-DD"),
              dataModal: moment.utc(consultas[i].date_at).format("YYYY-MM-DD"),
              hora: this.consulta.hora,
              horaModal: this.consulta.hora,
              sala: this.consulta.sala,
              profissional: consultas[i].id_professional,
              patient: consultas[i].id_patient,
              numGuia: consultas[i].numeroguia,
              numGuia2: consultas[i].numguia2,
              dataGuia1: consultas[i].dataguia1,
              dataGuia2: consultas[i].dataguia2,
              statusconsulta: consultas[i].statusconsulta
            });
          }
        }

        this.consultasRecorrentesValidacao.forEach(async (elem) => {
          const [res1, res2] = await Promise.all([
            this.$http.post(
              `${process.env.VUE_APP_API_BASE_URL}valida/tempo-consulta`,
              elem
            ),
            this.$http.post(`${process.env.VUE_APP_API_BASE_URL}valida-consulta`, elem),
          ]);

          if (res1.status == 201 || res1.status == 203) {
            elem.horaConflito = true;
            elem.error = res1.body.error;
            if (elem.error == "profissional_ocupation") {
              elem.message = `Profissional ocupado às ${res1.body.consulta.hour_at} por ${res1.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
                }`;
            }
            if (elem.error == "sala_ocupation") {
              elem.message = `Sala ocupada às ${res1.body.consulta.hour_at} por ${res1.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
                }`;
            }
            this.count = this.count + 1;
          } else if (res2.status == 201 || res2.status == 203) {
            elem.horaConflito = true;
            elem.error = res2.body.error;
            if (elem.error == "profissional_ocupation") {
              elem.message = `Profissional ocupado às ${res2.body.consulta.hour_at} por ${res2.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
                }`;
            }
            if (elem.error == "sala_ocupation") {
              elem.message = `Sala ocupada às ${res2.body.consulta.hour_at} por ${res2.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
                }`;
            }
            this.count = this.count + 1;
          } else {
            elem.horaConflito = false;
            elem.error = null;
            if (this.recorrencia == 0) {
              this.count = 0;
            }
          }
        });
      }
    },

    postConsulta() {
      return new Promise((resolve, reject) => {
        this.$http
          .post(`${process.env.VUE_APP_API_BASE_URL}valida/tempo-consulta`, this.consulta)
          .then((res) => {
            
            if (res.status === 201) {
              this.message = `Sala ocupada às ${res.body.consulta.hour_at}`;
              reject(new Error(this.message));
            } else if (res.status === 203) {
              this.message = `Profissional ocupado às ${res.body.consulta.hour_at}`;
              reject(new Error(this.message));
            } else {
              return this.$http.post(
                `${process.env.VUE_APP_API_BASE_URL}valida-consulta`,
                this.consulta
              );
            }
          })
          .then((res) => {
            if (res.status === 201) {
              this.mensagem = "Horário indisponível para essa sala";
              this.message = `Sala ocupada às ${res.body.consulta.hour_at}`;
              reject(new Error(this.message));
            } else if (res.status === 203) {
              this.mensagem = "Horário indisponível para esse profissional";
              this.message = `Profissional ocupado às ${res.body.consulta.hour_at}`;
              reject(new Error(this.message));
            } else {
              return this.$http
                .post(`${process.env.VUE_APP_API_BASE_URL}consultas/atualizar`, {
                  consulta: this.consulta,
                })
                .then(() => {
                  this.sucesso = true;
                  this.mensagem = "Consulta alterada com sucesso";
                  setTimeout(() => {
                    this.sucesso = false;
                  }, 3000);
                  resolve(res);
                });
            }
          });
      });
    },

    salvarConsultaModal(elem) {
      elem.data = moment.utc(elem.dataModal).format("YYYY/MM/DD");

      // Promise objects for each HTTP requests
      const requestValidaConsulta = this.$http.post(
        `${process.env.VUE_APP_API_BASE_URL}valida-consulta`,
        elem
      );
      const requestValidaTempoConsulta = this.$http.post(
        `${process.env.VUE_APP_API_BASE_URL}valida/tempo-consulta`,
        elem
      );

      Promise.all([requestValidaConsulta, requestValidaTempoConsulta])
        .then((results) => {
          const [resConsulta, resTempoConsulta] = results;
          if (resConsulta.status === 201 || resConsulta.status === 203) {
            if (resConsulta.body.error == "profissional_ocupation") {
              this.mensagem = `Profissional ocupado as ${resConsulta.body.consulta.hour_at} na sala ${resConsulta.body.consulta.sala}`;
            } else {
              this.mensagem = `Sala ${resConsulta.body.consulta.sala} ocupada as ${resConsulta.body.consulta.hour_at
                } por ${resConsulta.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
                }`;
            }
            this.colorAlertaAviso = "warning";
            this.alertaAviso = true;
            elem.horaConflito = true;
          }

          if (resTempoConsulta.status === 201 || resTempoConsulta.status === 203) {
            if (resTempoConsulta.body.error == "profissional_ocupation") {
              this.mensagem = `Profissional ocupado as ${resTempoConsulta.body.consulta.hour_at} na sala ${resTempoConsulta.body.consulta.sala}`;
            } else {
              this.mensagem = `Sala ${resTempoConsulta.body.consulta.sala} ocupada as ${resTempoConsulta.body.consulta.hour_at
                } por ${resTempoConsulta.body.consulta.consult_time == 1
                  ? "50 minutos"
                  : "25 minutos"
                }`;
            }
            this.colorAlertaAviso = "warning";
            this.alertaAviso = true;
            elem.horaConflito = true;
          }
          if (
            !(resConsulta.status === 201 || resConsulta.status === 203) &&
            !(resTempoConsulta.status === 201 || resTempoConsulta.status === 203)
          ) {
            this.colorAlertaAviso = "success";
            this.alertaAviso = true;
            this.mensagem = "Horario disponivel";
            elem.horaConflito = false;
          }
          setTimeout(() => {
            this.alertaAviso = false;
          }, 4000);
        })
        .then(() => {
          this.consultaComHorarioConflito = this.consultasData.some(
            (c) => c.horaConflito === true
          );

          if (!this.consultaComHorarioConflito) {
            this.btnAtualizarConsultas = true;
          } else {
            this.btnAtualizarConsultas = false;
          }
        });
    },
    atualizaConsultaModal() {
      this.onSubmit();
      this.temRecorrencia = false;
      this.temRecorrenciaValor = false;
      this.temRecorrenciaTempo = false;
    },
    valorHoraInicial() {
      this.horaAuxiliar = this.consulta.hora;
    },

    async salasDisponiveis() {
      this.listaSalas = [];
      await this.listarSalas();

      if (this.consulta.sala != 0) {
        for (let index = this.listaSalas.length - 1; index >= 0; index--) {
          const item = this.listaSalas[index];
          if (
            ![0, this.consulta.sala, "Eventos"].includes(item.value) ||
            ![0, this.consulta.sala]
          ) {
            this.listaSalas.splice(index, 1);
          }
        }
      } else {
        this.listaSalas = [];
        this.$http
          .post(`${process.env.VUE_APP_API_BASE_URL}sala-consulta`, {
            dia: this.removerAcentosTrocarHifens(
              moment.utc(this.consulta.data).format("dddd")
            ),
            idProfessional: this.consulta.profissional,
            time: this.consulta.hora,
          })
          .then((res) => res.json())
          .then((res) => {
            for (let index = this.listaSalas.length - 1; index >= 0; index--) {
              const item = this.listaSalas[index];
              if (![0].includes(item.value)) {
                this.listaSalas.splice(index, 1);
              }
            }
            const sala = res[0].room;
            this.listaSalas.push({ label: "Online", value: 0 });
            this.listaSalas.push({
              label: `Sala: ${sala}`,
              value: sala,
            });
          });
      }
    },

    removerAcentosTrocarHifens(str) {
      var strSemAcentos = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      var strComUnderscores = strSemAcentos.replace(/-/g, "_");
      return strComUnderscores;
    },

    async retornaSala() {
      const dia = this.removerAcentosTrocarHifens(
        moment.utc(this.consulta.data).format("dddd")
      );


      try {
        
        this.$http
          .post(`${process.env.VUE_APP_API_BASE_URL}sala-consulta`, {
            dia,
            idProfessional: this.consulta.profissional,
            time: this.consulta.hora,
          })
          .then((res) => res.json())
          .then((res) => {
            this.consulta.sala = res[0].room;

            this.selecionaSala();

            for (let index = this.listaSalas.length - 1; index >= 0; index--) {
              const item = this.listaSalas[index];
              if (![0, this.consulta.sala].includes(item.value)) {
                this.listaSalas.splice(index, 1);
              }
            }
          });
      } catch (error) { }
    },

    async alteraProfissional() {
      await this.retornaSala();
      await this.salasDisponiveis();
    },

    async alteraDia() {
      this.consultasRecorrentesValidacao = []
      let recorrencia = await this.verificaRecorrencia();
      
      if (recorrencia.consultas?.length > 0) {
        this.temRecorrenciaData = true;
      }
      await this.retornaSala();
      await this.salasDisponiveis();
    },
    // async atualizaConsultaModalDataRecorrencia() {
    //   this.temRecorrenciaData = false;
    //   let recorrencia = await this.verificaRecorrencia();


    //   const dataAlterada = moment(this.consulta.data, "YYYY-MM-DD");

    //   const response = await this.$http.get(
    //     `${process.env.VUE_APP_API_BASE_URL}consulta/data/${this.consulta.id}`
    //   );

    //   let dataInicial = moment.utc(response.body[0].date_at).format("YYYY-MM-DD");


    //   dataInicial = moment.utc(dataInicial, "YYYY-MM-DD");
    //   let qtdDias = dataAlterada.diff(dataInicial, "days");

    //   if (qtdDias > 0) {
    //     recorrencia.consultas.forEach((c) => {
    //       c.date_at = moment.utc(c.date_at);
    //       c.date_at.add(qtdDias, "days");
    //       c.date_at = c.date_at.format("YYYY-MM-DD");
    //     });
    //   } else {
    //     qtdDias = qtdDias * -1;
    //     recorrencia.consultas.forEach((c) => {
    //       c.date_at = moment.utc(c.date_at);
    //       c.date_at.subtract(qtdDias, "days");
    //       c.date_at = c.date_at.format("YYYY-MM-DD");
    //     });
    //   }

    //   await this.verificaConflitoRecorrencia(recorrencia);

    //   const error = this.consultasRecorrentesValidacao.filter((x) => x.error != null);

    //   if (error.length > 0) {
    //     setTimeout(() => {
    //       this.modalDataOcupada = true;
    //       this.btnAtualizarConsultas = true;
    //       this.mensagemModal = "Por favor, troque a data ou a hora da consulta";
    //       this.corModal = "warning";
    //     }, 1000);
    //   } else {
    //     this.modalDataOcupada = true;
    //     this.btnAtualizarConsultas = true;
    //     this.mensagemModal = "Confirme as alterações";
    //     this.corModal = "success";
    //   }
    // },

    async atualizaConsultaModalDataRecorrencia() {
      this.temRecorrenciaData = false;
      let recorrencia = await this.verificaRecorrencia();

      const dataAlterada = moment.utc(this.consulta.data, "YYYY-MM-DD");
      const response = await this.$http.get(
        `${process.env.VUE_APP_API_BASE_URL}consulta/data/${this.consulta.id}`
      );
      let dataInicial = moment.utc(response.body[0].date_at).format("YYYY-MM-DD");

      dataInicial = moment.utc(dataInicial, "YYYY-MM-DD");
      let qtdDias = dataAlterada.diff(dataInicial, "days");


      if (qtdDias > 0) {
        recorrencia.consultas.forEach((c) => {
          c.date_at = moment.utc(c.date_at);
          c.date_at.add(qtdDias, "days");
          c.date_at = c.date_at.format("YYYY-MM-DD");
        });
      } else {
        qtdDias = qtdDias * -1;
        recorrencia.consultas.forEach((c) => {
          c.date_at = moment.utc(c.date_at);
          c.date_at.subtract(qtdDias, "days");
          c.date_at = c.date_at.format("YYYY-MM-DD");
        });
      }


      await this.verificaConflitoRecorrencia(recorrencia);

      const error = this.consultasRecorrentesValidacao.filter((x) => x.error != null);

      if (error.length > 0) {
        setTimeout(() => {
          this.modalDataOcupada = true;
          this.btnAtualizarConsultas = true;
          this.mensagemModal = "Por favor, troque a data ou a hora da consulta";
          this.corModal = "warning";
        }, 1000);
      } else {
        this.modalDataOcupada = true;
        this.btnAtualizarConsultas = true;
        this.mensagemModal = "Confirme as alterações";
        this.corModal = "success";
      }
    },

    atualizaConsultaModalData() {
      this.temRecorrenciaData = false;
      this.onSubmit();
    },

    async retornaSalaConsultaRecorrente(diaConsulta, idProfissional, time) {
      const dia = this.removerAcentosTrocarHifens(moment.utc(diaConsulta).format("dddd"));
      try {
        const response = await this.$http.post(
          `${process.env.VUE_APP_API_BASE_URL}sala-consulta`,
          {
            dia,
            idProfessional: idProfissional,
            time: time,
          }
        );
        const res = await response.json();

        return res[0].room;
      } catch (error) {
        console.error(error);
      }
    },
    async verificaConflitoRecorrencia(recorrencia) {
      
      this.consultasRecorrentesValidacao = [];
      this.consultasRecorrentesValidacao = [];

      await this.retornaSala();
      await this.salasDisponiveis();

      if (this.consulta.data != this.data) {
        if (recorrencia.result) {
          for (let i = 0; i < recorrencia.consultas.length; i++) {
            this.consultasRecorrentesValidacao.push({
              id: recorrencia.consultas[i].id,
              data: moment.utc(recorrencia.consultas[i].date_at).format("YYYY-MM-DD"),
              dataModal: moment.utc(recorrencia.consultas[i].date_at).format("YYYY-MM-DD"),
              hora: this.consulta.hora,
              horaModal: this.consulta.hora,
              profissional: recorrencia.consultas[i].id_professional,
              patient: recorrencia.consultas[i].id_patient,
              hora: this.consulta.hora,
              tempo_consulta: this.consulta.tempo_consulta,
              sala: await this.retornaSalaConsultaRecorrente(
                recorrencia.consultas[i].date_at,
                recorrencia.consultas[i].id_professional,
                this.consulta.hora
              ),
              numGuia: recorrencia.consultas[i].numeroguia,
              numGuia2: recorrencia.consultas[i].numguia2,
              dataGuia1: recorrencia.consultas[i].dataguia1,
              dataGuia2: recorrencia.consultas[i].dataguia2,
              statusconsulta: recorrencia.consultas[i].statusconsulta,
            });
          }

          this.consultasRecorrentesValidacao.unshift({
            id: this.$route?.query?.id ? this.$route?.query?.id : "",
            data: moment.utc(this.consulta.data).format("YYYY-MM-DD"),
            dataModal: moment.utc(this.consulta.data).format("YYYY-MM-DD"),
            hora: this.consulta.hora,
            horaModal: this.consulta.hora,
            sala: this.consulta.sala,
            profissional: this.consulta.profissional,
            patient: this.consulta.patient,
            tempo_consulta: this.consulta.tempo_consulta,
            numGuia: this.consulta.numGuia,
            numGuia2: this.consulta.numGuia2,
            dataGuia1: this.consulta.dataGuia1,
            dataGuia2: this.consulta.dataGuia2,
            statusconsulta: this.consulta.statusconsulta
          });

          for (const elem of this.consultasRecorrentesValidacao) {
            const [res1, res2] = await Promise.all([
              this.$http.post(
                `${process.env.VUE_APP_API_BASE_URL}valida/tempo-consulta`,
                elem
              ),
              this.$http.post(`${process.env.VUE_APP_API_BASE_URL}valida-consulta`, elem),
            ]);

            if (res1.status == 201 || res1.status == 203) {
              elem.horaConflito = true;
              elem.error = res1.body.error;
              if (elem.error == "profissional_ocupation") {
                elem.message = `Profissional ocupado às ${res1.body.consulta.hour_at
                  } por ${res1.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
                  }`;
              }
              if (elem.error == "sala_ocupation") {
                elem.message = `Sala ocupada às ${res1.body.consulta.hour_at} por ${res1.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
                  }`;
              }
              this.count = this.count + 1;
            } else if (res2.status == 201 || res2.status == 203) {
              elem.horaConflito = true;
              elem.error = res2.body.error;
              if (elem.error == "profissional_ocupation") {
                elem.message = `Profissional ocupado às ${res2.body.consulta.hour_at
                  } por ${res2.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
                  }`;
              }
              if (elem.error == "sala_ocupation") {
                elem.message = `Sala ocupada às ${res2.body.consulta.hour_at} por ${res2.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
                  }`;
              }
              this.count = this.count + 1;
            } else {
              elem.horaConflito = false;
              elem.error = null;
              if (this.recorrencia == 0) {
                this.count = 0;
              }
            }
          }
        }
      }
    },

    async verificaHorarioRecorrencia() {
      this.recorrencia = null;


      await this.retornaSala();
      await this.salasDisponiveis();

      if (this.consulta.hora != this.horaAuxiliar) {
        this.temRecorrencia = await this.verificaRecorrencia();
        this.temRecorrenciaData = false;
        this.dataAlteradaBlur = moment.utc(this.consulta.data, "YYYY-MM-DD");
        let qtdDias = this.dataAlteradaBlur.diff(this.dataInicialBlur, "days");
        if (this.temRecorrencia.result) {
          for (let i = 0; i < this.temRecorrencia.consultas.length; i++) {
            this.consultasRecorrentesValidacao.push({
              id: this.temRecorrencia.consultas[i].id,
              data: moment
                .utc(this.temRecorrencia.consultas[i].date_at)
                .add(qtdDias, "days")
                .format("YYYY-MM-DD"),
              dataModal: moment
                .utc(this.temRecorrencia.consultas[i].date_at)
                .add(qtdDias, "days")
                .format("YYYY-MM-DD"),
              numGuia: this.temRecorrencia.consultas[i].numeroguia,
              numGuia2: this.temRecorrencia.consultas[i].numguia2,
              dataGuia1: this.temRecorrencia.consultas[i].dataguia1,
              dataGuia2: this.temRecorrencia.consultas[i].dataguia2,
              hora: this.consulta.hora,
              horaModal: this.consulta.hora,
              sala: this.consulta.sala,
              profissional: this.temRecorrencia.consultas[i].id_professional,
              patient: this.temRecorrencia.consultas[i].id_patient,
              tempo_consulta: this.consulta.tempo_consulta,
              statusconsulta: this.consulta.statusconsulta
            });
          }

          this.consultasRecorrentesValidacao.unshift({
            id: this.$route?.query?.id ? this.$route?.query?.id : "",
            data: moment.utc(this.consulta.data).format("YYYY-MM-DD"),
            dataModal: moment.utc(this.consulta.data).format("YYYY-MM-DD"),
            hora: this.consulta.hora,
            horaModal: this.consulta.hora,
            sala: this.consulta.sala,
            profissional: this.consulta.profissional,
            patient: this.consulta.patient,
            tempo_consulta: this.consulta.tempo_consulta,
            numGuia: this.consulta.numGuia,
            numGuia2: this.consulta.numGuia2,
            dataGuia1: this.consulta.dataGuia1,
            dataGuia2: this.consulta.dataGuia2,
            statusconsulta: this.consulta.statusconsulta
          });

          for (const elem of this.consultasRecorrentesValidacao) {
            const [res1, res2] = await Promise.all([
              this.$http.post(
                `${process.env.VUE_APP_API_BASE_URL}valida/tempo-consulta`,
                elem
              ),
              this.$http.post(`${process.env.VUE_APP_API_BASE_URL}valida-consulta`, elem),
            ]);

            if (res1.status == 201 || res1.status == 203) {
              elem.horaConflito = true;
              elem.error = res1.body.error;
              if (elem.error == "profissional_ocupation") {
                elem.message = `Profissional ocupado às ${res1.body.consulta.hour_at
                  } por ${res1.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
                  }`;
              }
              if (elem.error == "sala_ocupation") {
                elem.message = `Sala ocupada às ${res1.body.consulta.hour_at} por ${res1.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
                  }`;
              }
              this.count = this.count + 1;
            } else if (res2.status == 201 || res2.status == 203) {
              elem.horaConflito = true;
              elem.error = res2.body.error;
              if (elem.error == "profissional_ocupation") {
                elem.message = `Profissional ocupado às ${res2.body.consulta.hour_at
                  } por ${res2.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
                  }`;
              }
              if (elem.error == "sala_ocupation") {
                elem.message = `Sala ocupada às ${res2.body.consulta.hour_at} por ${res2.body.consulta.consult_time == 1 ? "50 minutos" : "25 minutos"
                  }`;
              }
              this.count = this.count + 1;
            } else {
              elem.horaConflito = false;
              elem.error = null;
              if (this.recorrencia == 0) {
                this.count = 0;
              }
            }
          }

          const error = this.consultasData.filter((x) => x.error != null);
          if (error.length > 0) {
            setTimeout(() => {
              this.modalDataOcupada = true;
            }, 1000);
          }
        }
      }
    },

    cancelarAlteracaoRecorrente() {
      this.consulta.hora = this.horaAuxiliar;
      this.temRecorrencia = false;
    },
    fechaModal() {
      this.consulta.tempo_consulta = this.consulta.aux_tempo_consulta
    },

    fechaModalHora() {
      this.consulta.hora = this.consulta.aux_hora
    },
    fechaModalData() {
      this.consulta.data = this.consulta.data_inicial
    },

    async onSubmit() {
      if (
        (this.consulta.statusConsulta == "Não Compareceu" ||
          this.consulta.statusConsulta == "Sem Protocolo") &&
        this.consulta.valor == this.estadoInicial.valor &&
        this.consulta.data == this.estadoInicial.data
      ) {
        this.$http
          .post(`${process.env.VUE_APP_API_BASE_URL}consultas/atualizar`, {
            consulta: this.consulta,
          })
          .then(() => {
            this.sucesso = true;
            this.mensagem = "Consulta alterada com sucesso";
            setTimeout(() => {
              this.sucesso = false;
            }, 3000);
          });
        return;
      }
      try {
        await this.postConsulta();
      } catch (error) {
        this.aviso = true;
        this.mensagem = error;

        setTimeout(() => {
          this.aviso = false;
        }, 5000);
      }
    },
    atualizarConsultaRecorrente() {
      this.verificaHoraConsulta();
      this.temRecorrencia = false;
      this.temRecorrenciaTempo = false;
    },
    verificaRecorrencia() {
      return new Promise((resolve, reject) => {
        this.$http
          .post(
            `${process.env.VUE_APP_API_BASE_URL}consultas/verifica-recorrencia/${this.consulta.patient}`,
            this.consulta
          )
          .then((res) => res.json())
          .then((res) => {


            this.consultasData = res.consultas;
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    verificaHoraConsulta() {
      const temRecorrenciaConflito = this.consultasRecorrentesValidacao.filter(
        (c) => c.horaConflito == true
      );

      if (temRecorrenciaConflito.length == 0) {
        this.btnAtualizarConsultas = true;
        this.modalDataOcupada = true;
        this.mensagemModal = "Confirme as alterações";
        this.corModal = "success";
      } else {
        this.btnAtualizarConsultas = true;
        this.modalDataOcupada = true;
        this.mensagemModal = "Por favor, troque a data ou a hora da consulta";
        this.corModal = "warning";
      }
    },
    showFieldsYes() {
      if ([1, 6, 9].includes(this.financeiro.convenio)) {
        (this.dataPagamentoShow = true),
          (this.mostraMulta = true),
          (this.financeiro.valorMulta = this.financeiro.valor);
      } else {
        (this.dataPagamentoShow = false),
          (this.mostraMulta = false),
          (this.financeiro.valorMulta = this.financeiro.valor);

        this.financeiro.formaPagamento = "convenio";
        if (this.financeiro.convenio == 7) {
          this.dataPagamentoShow = null;
        }
      }
    },

    showFieldsNo() {
      if ([1, 6, 9].includes(this.financeiro.convenio)) {
        (this.dataPagamentoShow = false),
          (this.mostraMulta = false),
          (this.financeiro.valorMulta = 0);
        this.financeiro.formaPagamento = "isento";
      } else if (this.financeiro.convenio == 7) {
        (this.dataPagamentoShow = false),
          (this.mostraMulta = false),
          (this.financeiro.valorMulta = 0);
        this.financeiro.formaPagamento = "isento";
      } else {
        (this.dataPagamentoShow = false),
          (this.mostraMulta = false),
          (this.financeiro.valorMulta = 0);
        this.financeiro.formaPagamento = "isento";
      }
    },

    sobrescreverGuia() {
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}consulta/sobrescrever-guia`, {
          idConsulta: this.guiaProximaConsulta.idConsulta,
          guias: [
            { guia: this.consulta.numGuia, data: this.consulta.dataGuia1 },
            { guia: this.consulta.numGuia2, data: this.consulta.dataGuia2 },
          ],
        })
        .then((res) => {
          this.temGuia = false;
        });
    },
    cancelaModalGuia() {
      this.temGuia = false;
    },
    post() {
      this.financeiro.idConsulta = this.$route.query.id;

      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}profisisonal-financeiro`, {
          ...this.financeiro,
          consulta: { ...this.consulta, evolucaoTexto: this.editorData },
        })
        .then((res) => res.json())
        .then((res) => {
          if (
            this.financeiro.adiantamento &&
            this.financeiro.checkMulta == "NAO" &&
            this.financeiro.compareceu == 2
          ) {
            this.temAdintamentoFinanceiro = true;
          }

          if (
            res.temGuia &&
            this.financeiro.checkMulta == "NAO" &&
            ![1, 6].includes(this.financeiro.convenio) &&
            this.financeiro.compareceu != 1
          ) {
            this.temGuia = true;
            this.guiaProximaConsulta = {
              idConsulta: res.id,
              dataProximaConsulta: moment.utc(res.date_at).format("DD/MM/YYYY"),
              guias: [
                {
                  guia: res.numeroguia ? res.numeroguia : "-",
                  data: res.dataguia1 ? moment.utc(res.dataguia1).format("DD/MM/YYYY") : "-",
                },
                {
                  guia: res.numguia2 ? res.numguia2 : "-",
                  data: res.dataguia2 ? moment.utc(res.dataguia2).format("DD/MM/YYYY") : "-",
                },
              ],
            };
          }
          this.handleMulta();
          this.sucesso = true;
          this.mensagem = "Dados financeiros atualizados";
          setTimeout(() => {
            this.consulta.multa = 0;
            this.sucesso = false;
          }, 3000);
          this.desabilitarTabEvolucao = this.financeiro.compareceu != 1;
        })
        .catch((err) => {
          this.mensagem = "Ocorreu um erro ao salvar os dados financeiros";
          this.aviso = true;
        });
    },

    async salvaFinanceiro() {
      const dataAtual = moment().startOf("day"); // Define a hora para meia-noite, iniciando o dia
      const dataConsulta = moment.utc(this.consulta.data).startOf("day"); // Garante que também está começando à meia-noite

      const diffDias = dataConsulta.diff(dataAtual, "days");


      if (diffDias <= 0) {
        this.financeiro.isDateConsultSameDateToday == true
      }
      // this.isDateConsultSameDateToday = moment(this.consulta.data)
      event.preventDefault();

      let user = localStorage.getItem("type_name");

      // this.financeiro.datePayment = moment(new Date()).format('YYYY-MM-DD')
      this.financeiro.dataConsulta = this.consulta.data;
      if (
        this.financeiro.copyAdiantamento == true &&
        this.financeiro.adiantamento == false &&
        this.financeiro.compareceu == 3
      ) {
        this.$http
          .post(
            `${process.env.VUE_APP_API_BASE_URL}profisisonal-financeiro/adiantamento`,
            this.financeiro
          )
          .then((res) => {
            this.listarConsultas(this.financeiro.idConsulta);
            this.sucesso = true;
            this.mensagem = "Adiantamento salvo com sucesso";
            setTimeout(() => {
              this.sucesso = false;
            }, 3000);
          });

        return;
      }

      if (
        (this.financeiro.adiantamento == true &&
          this.financeiro.isDateConsultSameDateToday == false) ||
        (this.financeiro.adiantamento == true &&
          this.financeiro.user == "Administrador" &&
          this.financeiro.compareceu == 3)
      ) {
        this.$http
          .post(
            `${process.env.VUE_APP_API_BASE_URL}profisisonal-financeiro/adiantamento`,
            this.financeiro
          )
          .then((res) => {
            this.listarConsultas(this.financeiro.idConsulta);
            this.sucesso = true;
            this.mensagem = "Adiantamento salvo com sucesso";
            setTimeout(() => {
              this.sucesso = false;
            }, 3000);
          });
        return;
      }
      if (
        (this.financeiro.compareceu == 3 && this.financeiro.tipoServico == "AVALIAÇÃO") ||
        (this.financeiro.compareceu == 3 && this.financeiro.tipoServico == "CONSULTA")
      ) {
        this.mensagem = "Necessário informar se o paciente compareceu";
        this.aviso = true;
      } else {
        if ([1, 6, 9].includes(this.financeiro.convenio)) {

          if (
            this.financeiro.compareceu == 1 &&
            this.financeiro.formaPagamento == "nao_pagou"
          ) {
            this.post();
            this.desabilitarTabEvolucao = false;
            setTimeout(() => {
              if (user == "Profissional") {
                const elem = document.querySelector("#tab_evolucao .nav-link");

                elem.click();
              }
            }, 1000);
            return;
          } else if (this.financeiro.compareceu == 2) {
            if (this.financeiro.checkMulta == "SIM") {
              this.post();
              this.desabilitarTabEvolucao = false;

              setTimeout(() => {
                if (user == "Profissional") {
                  const elem = document.querySelector("#tab_evolucao .nav-link");

                  elem.click();
                }
              }, 1000);
            } else {
              this.post();
              this.desabilitarTabEvolucao = false;

              setTimeout(() => {
                if (user == "Profissional") {
                  const elem = document.querySelector("#tab_evolucao .nav-link");

                  elem.click();
                }
              }, 1000);
            }
          } else {
            if (
              this.financeiro.datePayment == null &&
              this.financeiro.compareceu == 1 &&
              this.financeiro.formaPagamento != "isento"
            ) {
              this.mensagem = "Necessário informar a data de pagamento";
              this.aviso = true;
            } else {
              this.post();
              this.desabilitarTabEvolucao = false;

              setTimeout(() => {
                if (user == "Profissional") {
                  const elem = document.querySelector("#tab_evolucao .nav-link");

                  elem.click();
                }
              }, 1000);
            }
          }
        } else {
          if (this.financeiro.convenio == 7) {



            if (this.financeiro.compareceu == 2) {

              if (this.financeiro.checkMulta == "SIM") {
                this.post();
                this.desabilitarTabEvolucao = false;
                setTimeout(() => {
                  if (user == "Profissional") {
                    const elem = document.querySelector("#tab_evolucao .nav-link");

                    elem.click();
                  }
                }, 1000);
              } else {
                this.post();
                this.desabilitarTabEvolucao = false;

                setTimeout(() => {
                  if (user == "Profissional") {
                    const elem = document.querySelector("#tab_evolucao .nav-link");

                    elem.click();
                  }
                }, 1000);
              }
            } else {

              let naoTemGuia =
                (this.consulta.numGuia == null || this.consulta.numGuia == "") &&
                (this.consulta.numGuia2 == null || this.consulta.numGuia2 == "");




              if (
                this.financeiro.datePayment == null &&
                this.financeiro.checkCopart != "NAO" &&
                naoTemGuia == false &&
                this.financeiro.formaPagamento != "isento"
              ) {

                this.mensagem = "Necessário informar a data de pagamento";
                this.aviso = true;

                setTimeout(() => {
                  this.aviso = false;
                }, 2000);
              } else {
                if (
                  ((this.financeiro.checkCopart == "SIM" &&
                    this.financeiro.formPagamentoCopart == null) ||
                    this.financeiro.checkCopart == null) &&
                  this.financeiro.formaPagamento != "isento"
                ) {
                  this.mensagem =
                    "Necessário informar se houve coparticipação e a forma de pagamento";
                  this.aviso = true;

                  setTimeout(() => {
                    this.aviso = false;
                  }, 2000);
                } else {
                  this.post();
                  this.desabilitarTabEvolucao = false;

                  if (user == "Profissional") {
                    setTimeout(() => {
                      if (user == "Profissional") {
                        const elem = document.querySelector("#tab_evolucao .nav-link");

                        elem.click();
                      }
                    }, 1000);
                  }
                }
              }
            }
          } else {
            this.post();
            this.desabilitarTabEvolucao = false;

            setTimeout(() => {
              if (user == "Profissional") {
                const elem = document.querySelector("#tab_evolucao .nav-link");

                elem.click();
              }
            }, 1000);
          }
        }
      }
    },
    mudaAdiantamento() {
      this.financeiro.datePayment = moment.utc(new Date()).format("YYYY-MM-DD")
      this.financeiro.idConsulta = this.consulta.id;
      this.financeiro.idPaciente = this.consulta.patient;
      this.financeiro.idProfissional = this.consulta.profissional;
      this.financeiro.idServico = this.consulta.idServico;

      this.financeiro.adiantamento = !this.financeiro.adiantamento;

      if (this.financeiro.adiantamento == true) {
        this.disabledCompareceu = true;
        this.financeiro.compareceu = 3;
        this.dataPagamentoShow = true;
        // this.disabledCompareceu = true;
        this.financeiro.convenioAtual = this.financeiro.convenio;
        this.financeiro.convenio = 1;
        this.financeiro.compareceu = 3;
        (this.formaPagamento = [
          { label: "DINHEIRO", value: "dinheiro" },
          { label: "PIX", value: "pix" },
        ]),
          (this.financeiro.formaPagamento = "dinheiro");
      } else {
        this.disabledPayment = false;
        if (!this.financeiro.convenioAtual) {
          this.financeiro.convenioAtual = 1;
        }
        this.dataPagamentoShow = false;
        this.financeiro.convenio = this.financeiro.convenioAtual;
        this.disabledCompareceu = false;
        this.formaPagamento = [
          { label: "NÃO PAGOU", value: "nao_pagou" },
          { label: "DINHEIRO", value: "dinheiro" },
          { label: "CONVÊNIO", value: "convenio" },
          { label: "PIX", value: "pix" },
          { label: "ISENTO", value: "isento" },
        ];

        if (this.financeiro.convenio != 1) {
          this.disabledPayment = true;
          this.disabledCompareceu = false;
          this.financeiro.formaPagamento = "convenio";
        }
      }
    },
    handleMulta() {
      if (this.financeiro.compareceu == 2) {
        let valorMulta =
          this.financeiro.convenio == 1 ||
            this.financeiro.convenio == 6 ||
            this.financeiro.convenio == 9
            ? this.financeiro.valorMulta
            : this.consulta.valor;

        let status = this.financeiro.checkMulta === "SIM" ? "1" : "0";

        this.$http
          .post(`${process.env.VUE_APP_API_BASE_URL}financial-multa`, {
            idPaciente: this.financeiro.idPaciente,
            idConsulta: this.$route.query.id,
            valorMulta: valorMulta,
            checkMulta: this.financeiro.checkMulta,
            status: status,
          })
          .catch((err) => {
            this.mensagem = "Ocorreu um erro ao salvar os dados da multa";
            this.aviso = true;
          });
      }
    },
    selecionaCompareceu() {
      if ([1, 6, 7, 9].includes(this.financeiro.convenio)) {
        if (this.financeiro.convenio == 7) {
          if (this.financeiro.compareceu == 1) {
            this.dataPagamentoShow = false;
            this.mostrarRadiosMulta = false;
            this.financeiro.mostrarRadiosMulta = false;
            this.showCoparticipacao = true;
            this.showCheckCopart = true;
            this.showSelectCopart = true;
          }
          if (this.financeiro.compareceu == 2) {
            this.dataPagamentoShow = false;
            this.mostrarRadiosMulta = true;
            this.financeiro.mostrarRadiosMulta = false;
            this.showCoparticipacao = false;
            this.showCheckCopart = false;
          }
        }
        if (this.financeiro.compareceu === 1) {
          this.mostrarRadiosMulta = false;
          if (this.financeiro.formaPagamento == "isento") {
            this.dataPagamentoShow = false;
            this.mostraMulta = false;
          } else {
            this.dataPagamentoShow = true;
            this.mostrarRadiosMulta = false;
          }
        } else if (this.financeiro.compareceu == 2) {
          if ([1, 6, 9].includes(this.financeiro.convenio)) {
            // this.dataPagamentoShow = true;
            this.mostrarRadiosMulta = true;

            this.dataPagamentoShow = false;
          }
        } else {
          this.dataPagamentoShow = false;
          this.mostrarRadiosMulta = false;
        }
      } else {
        if (this.financeiro.compareceu == 1) {
          this.dataPagamentoShow = false;
          this.mostrarRadiosMulta = false;
          this.financeiro.mostrarRadiosMulta = false;
        } else {
          this.dataPagamentoShow = false;
          this.mostrarRadiosMulta = true;
          this.financeiro.mostrarRadiosMulta = false;
        }
      }
    },
    selecionaServico() {
      if (this.financeiro.tipoServico == "palestra") {
        this.disabledCompareceu = true;
        this.disabledConvenio = true;
      } else {
        this.disabledCompareceu = false;
        this.disabledConvenio = false;
      }
    },
    selecionaFormaPagamento() {
      const convenio = this.financeiro.convenio;

      if ([1, 6, 9].includes(convenio)) {
        if (this.financeiro.compareceu === 2) {
          this.mostraMulta = true;
        } else {
          this.mostraMulta = false;
        }
      }

      if (this.financeiro.formaPagamento == "nao_pagou") {
        this.dataPagamentoShow = false;
        this.financeiro.valorMulta = this.financeiro.valor;
      } else if (this.financeiro.formaPagamento == "isento") {
        this.dataPagamentoShow = false;
        this.financeiro.valorMulta = 0;
        this.mostraMulta = false;
      } else {
        this.financeiro.valorMulta = 0;
        this.dataPagamentoShow = true;
      }
    },
    cancelar() {
      this.darkModal = false;
    },
    cancelarDebitos() {
      this.customModal = false;
    },
    atualizarPagamento() {
      this.$http.post(`${process.env.VUE_APP_API_BASE_URL}pagamento-consultas-debitos`, {
        consultasEmDebito: this.arrDebitos,
      });
      this.arrDebitos.length = 0;
    },

    atualizarDebitos() {
      this.atualizarPagamento();
      this.showModal = false;
      this.controllerModal = true;
      this.customModal = true;
      this.arrDebitos.length = 0;
    },
    marcar(item, index) {
      item.marcado = !item.marcado;
      this.multa = item;

      let arrDebitos = this.arrDebitos;

      if (item.marcado) {
        if (!arrDebitos.includes(item.id)) {
          arrDebitos.push({
            id: item.id,
            datePagamento: this.dataModal,
            pagamento: this.pagamentoModalSelecionado,
            verificaMultas: this.resMulta,
            idPaciente: this.consulta.patient,
          });
        }
      } else {
        let idx = arrDebitos.indexOf(item.id);
        if (idx !== -1) {
          arrDebitos.splice(idx, 1);
        }
      }
    },
    buscaMulta() {
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}financial/lista-multa/`, {
          idPaciente: this.consulta?.nome,
          idConsulta: this.consulta.id,
        })
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            item.marcado = false;
            item.date_at = moment.utc(item.date_at).format("DD/MM/YYYY");
            item.multa = item.multa.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            });
          });
          this.resMulta = res.length;
          this.dadosPacienteMulta = res;
          if (this.dadosPacienteMulta.length > 0) {
            if (localStorage.getItem("type") != 2) {
              this.darkModal = true;
              this.showModal = true;
            }
          }
        });
    },
    onFileSelected(event) {
      this.selectedFile = event.target.files[0];
    },
    removerImagem() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}delete-imagem/${this.consulta.id}`)
        .then((res) => {
          this.imagemVisivel = true;
          this.mostrarInputImagemIvolucao = true;
          this.disabledTextEvolution = false;
        });
    },
    imputFile() {
      var file = document.querySelector("#fileinput").files;

      this.disabledTextEvolution = true;
    },
    async onUpload() {
      var nameEvolutions = [];

      if (this.editorData == "" || this.editorData == null) {
        var files = document.querySelector("#fileinput").files;

        for (let index = 0; index < files.length; index++) {
          const file = files[index];

          nameEvolutions.push({
            name: `${this.consulta.profissional}-${this.consulta.id}-${this.consulta.patient}-${index}`,
          });

          const reader = new FileReader();
          reader.readAsDataURL(file);

          await new Promise((resolve, reject) => {
            reader.onload = (event) => {
              this.$http
                .post(`${process.env.VUE_APP_API_BASE_URL}imagem/evolucao`, {
                  nameEvolution: nameEvolutions[index].name,
                  data: event.target.result,
                })
                .then((res) => {
                  this.consulta.imagemEvolution = res.bodyText;
                  resolve(); // Resolves the promise when the POST request is done
                })
                .catch((error) => {
                  reject(error); // Rejects the promise if there is an error
                });
            };
          });
        }

        nameEvolutions = JSON.stringify(nameEvolutions);

        this.$http.post(
          `${process.env.VUE_APP_API_BASE_URL}evolucao-imagem/${this.consulta.id}`,
          { nameEvolution: nameEvolutions, type: "img" }
        );

        this.mostrarInputImagemIvolucao = false;
        const imgEvo = JSON.parse(nameEvolutions);

        this.recuperaImagens(imgEvo);

        // Make sure 'event' is defined in the context
        this.imagemVisivel = false;
        this.$forceUpdate(); // Fix the typo and force update the Vue instance
      } else {
        this.$http
          .post(
            `${process.env.VUE_APP_API_BASE_URL}evolucao-imagem/${this.consulta.id}`,
            { evolution: this.editorData, type: "text" }
          )
          .then((res) => {
            this.sucesso = true;
            this.mensagem = "Evolução salva com sucesso";
            // this.editorData = "...........";
            setTimeout(() => {
              this.sucesso = false;
            }, 1000);
          });
      }
    },

    marcarConsulta() {
      const user = localStorage.getItem("type_name");
      if (user == "Profissional") {
        if (this.selectNovaConsulta == 0) {
          this.proximaConsultaShow = false;
        } else {
          this.proximaConsultaShow = true;
        }
      }
    },
    retornaNumConsulta() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}qtd-consulta/${this.idPatient}`)
        .then((res) => res.json())
        .then((res) => {
          const user = localStorage.getItem("type_name");
          res[0].count = parseInt(res[0].count);

          if (user != "Recepcionista" && user != "Profissional") {
            if (res[0].count == 0) {
              this.showProximaConsulta = true;
            } else {
              this.showAlteraProximaConsulta = true;
            }
          }
        });
    },
    changeSelectAlteraConsulta() {
      if (this.selectAlteraConsulta == 1) {
        this.proximaConsultaShow = true;
        this.$http
          .get(
            `${process.env.VUE_APP_API_BASE_URL}proxima-consulta/${this.consulta.profissional}`
          )
          .then((res) => res.json())
          .then((res) => {
            this.valoresConsultaAlterada.id = res[0].id;
            (this.valoresConsultaAlterada.dia = moment
              .utc(res[0].date_at)
              .format("YYYY-MM-DD")),
              (this.valoresConsultaAlterada.hora = res[0].hour_at);
            this.valoresConsultaAlterada.sala = res[0].sala;
            this.valoresConsultaAlterada.profisional = res[0].id_professional;
          });
      } else {
        this.proximaConsultaShow = false;
      }
    },
    alteraConsulta() {
      if (
        this.valoresConsultaAlterada.dia == "" ||
        this.valoresConsultaAlterada.hora == ""
      ) {
        this.avisoData = true;
        this.mensagem = "Campos não podem estar vazios";
        return;
      } else {
        this.valoresConsultaAlterada.data = moment
          .utc(this.valoresConsultaAlterada.dia)
          .format("YYYY/MM/DD");

        this.$http
          .post(
            `${process.env.VUE_APP_API_BASE_URL}valida-consulta`,
            this.valoresConsultaAlterada
          )
          .then((res) => {
            if (res.status == 201) {
              alert("Sala ocupada");
            }
            if (res.status == 203) {
              alert("Sala ocupada");
            }
            if (res.status == 200) {
              this.$http
                .post(
                  `${process.env.VUE_APP_API_BASE_URL}altera-consulta`,
                  this.valoresConsultaAlterada
                )
                .then((res) => {
                  this.showAlteraProximaConsulta = false;
                });
            }
          });
      }
    },
    novaConsulta() {
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}post-consulta`, this.consulta)
        .then((res) => {
          this.showProximaConsulta = false;
        })
        .catch((err) => {
          if (err.status == 404) {
            this.avisoData = true;
            this.mensagem = "Data e horario já esta em uso";
          }
          if (err.status == 405) {
            this.avisoData = true;
            this.mensagem = "Prossional está ocupado nesse horario";
          }
        });
    },
    habilitarCoparticapao() {
      if (this.financeiro.convenio === 7) {
        if (this.financeiro.checkMulta == "SIM" || this.financeiro.checkMulta == "SIM") {
          this.showCoparticipacao = false;
          this.showCheckCopart = false;
        } else {
          this.showCoparticipacao = true;
          this.showCheckCopart = true;
        }
      } else {
        this.showCoparticipacao = false;
        this.showCheckCopart = false;
        if (this.financeiro.coparticipacao != 0) {
          this.financeiro.coparticipacao = 0;
        }
      }
    },
    atualizarIntegracao() { },
    // salvaAdiantamento() {

    //   this.adiantamento.data = new Date();
    //   this.adiantamento.idConsulta = this.consulta.id;
    //   this.adiantamento.idPaciente = this.consulta.id_paciente;
    //   this.adiantamento.idProfissional = this.consulta.id_profissional;
    //   this.adiantamento.id_convenio = this.consulta.convenio;
    // },
    formataValor() {
      this.adiantamento.valor = parseFloat(this.adiantamento.valor).toFixed(2);
      this.adiantamento.valor = `R$ ${this.adiantamento.valor.replace(".", ",")}`;
    },
    focusValorConsulta() {
      this.valorAuxiliarConsulta = this.consulta.valor;
    },
    selectCopTrue() {
      this.showSelectCopart = true;
    },
    selectCopFalse() {
      this.showSelectCopart = false;
    },
  },
  computed: {
    formattedDataConsulta() {
      return moment.utc(this.consulta.data).format("DD/MM/YYYY");
    },
  },
  watch: {
    arrDebitos: {
      handler(newValue, oldValue) {
        if (newValue.length > 0) {
          this.desabilitarSomar = false;
        } else {
          this.desabilitarSomar = true;
        }
      },
    },
  },
  mounted() {
    this.listarPaciente();
    let user = localStorage.getItem("type_name");
    this.dataModal = moment.utc().format("YYYY-MM-DD");

    if (user == "Profissional" || user == "Administrador-master") {
      this.ShowUserEvolution = true;
      this.ShowUser = true;
      this.showValue = false;
      this.desabilitarData = true;
      this.desabilitarHora = true;
      this.desabilitarProfisional = true;
      this.desabilitaTempo = true;
      this.desabilitarSala = true;
    }

    if (user != "Recepcionista") {
      this.abaFinantial = true;
      this.protocolo = false;
    } else {
      this.desabilitaValorConsulta = false;
      this.protocolo = true;
      this.abaFinantial = false;
    }

    if (user == "Administrador") {
      this.desabilitaValorConsulta = false;
      this.protocolo = true;
      this.financeiro.user == "Administrador";
    }

    let id = this.$route?.query?.id ? this.$route?.query?.id : "";
    this.listarConsultas(id);

    this.paramVoltar = this.$route.params.voltar;
    this.query = this.$route?.query?.page ? this.$route?.query?.page : "";
    if (this.query == "integration") {
      this.vshowAtualizar = true;
    }

    this.listaPorfissionais();
    this.listarConvenio();
    setTimeout(() => {
      this.habilitarCoparticapao();
    }, 1000);

    this.mostraMulta = false;
  },
};
</script>

<style scoped>
.imagem-evolucao {
  width: 20rem;
  height: 20rem;
}

.imagem-evolucao img {
  max-width: 100%;
  margin-bottom: 2rem;
}

.d-flex {
  display: flex;
  gap: 1rem;
}

.btn-upload {
  border: none;
  border-radius: 5px;
  background-color: #ccc;
  margin-left: 9px;
  height: 45px;
  width: 190px;
  color: #696969;
  font-weight: 400;
  font-size: 18px;
  margin-bottom: 10px;
}

.btnVoltar {
  margin-right: 8px;
}

.btn-upload:hover {
  border: #696969;
  background-color: #fff;
  color: #696969;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.titulo-data-convneio {
  display: flex;
  justify-content: start;
  margin-top: 30px;
  margin-bottom: 25px;
}

.h3-convenio {
  display: flex;
  justify-content: center;
  margin-bottom: 5vh;
}

@media (max-width: 1400px) {
  .section-copart {
    display: flex;
  }

  .section-check {
    flex-direction: row;
    gap: 0px;
    justify-content: center;
    align-content: center;
    align-items: center;
  }
}

.section-check {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
}

.radios-multa-check {
  margin-left: 15px;
}

.div-check-multa {
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0 !important;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.div-check-multa p {
  margin-bottom: 0 !important;

  text-align: center;
}

.div-check-multa-div {
  margin-left: 2vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.div-body-modal {
  text-align-last: center;
}

.div-body-modal button {
  background: red;
  border: none;
  font-weight: 500;

  width: 10vw;
  border-radius: 10px;
  height: 2vw;
  color: white;
  transition: all 0.3s;
}

.modal-debitos .modal-content {
  width: 140%;
}

.section-modal-debitos {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  margin-top: 2vh;
}

.select-modal-pagamento {
  margin-top: 3vh;
}

.title-cite-modal {
  text-align: center !important;
}

.radios-nf {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.radio_button {}

.color-c3 {
  color: #c3c3c3;
}

.color-222 {
  color: #222222;
  font-weight: 600;
}

.inline_block {
  display: inline-block;
  margin-right: 20px;
}

.icon-item {
  color: rgb(42, 180, 42);
}

.tab_evolucao div.tab-pane.active {
  display: inline-block !important;
}

.ckeditor {
  margin-top: 1rem;
  position: relative;
}

.btnLer {
  position: absolute;
  top: 0px;
  right: 0px;
}

.div-flex {
  display: flex;
  align-items: flex-start;
  gap: 2rem;
  flex-direction: column;
}

.div-flex-d {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
}

.p_message {
  font-size: 0.7rem;
}

.input_modal {
  margin-bottom: 0px;
}

.ocupado {
  display: inline-block;
  font-size: 1.5rem;
  margin: auto;
  color: red;
}

.container-card {
  position: relative;
}

.container-card .status {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 1;
  background-color: #636f83;
  color: #fff;
  border-radius: 0.5rem;
  min-width: 100px;
  text-align: center;
}

@media (max-width: 768px) {
  .container-card span {
    margin-bottom: 5rem;
  }
}
</style>
